class gsapMayaaThemeExecution {
  constructor() {
    let getHeaderSetting = document.querySelector('[data-header-type]');
    let scrollDirectionSetting = document.querySelector('body');
    let announcementBar = document.querySelector('.announcement-bar-section');
    this.announcementBarHeight = 0;
    this.headerHeight = 0;
    this.rawHeaderHeight = 0;
    this.rawHeaderSetting = 'sticky';
    this.transparentHeader = 'false';
    this.lastFocusedSectionTab = null;
    this.viewportWidth = window.innerWidth;
    this.viewportHeight = window.innerHeight;
    this.scrollDirection = scrollDirectionSetting.getAttribute('data-scroll-direction');
    this.isFireFoxBrowser = false;
    if (navigator.userAgent.toLowerCase().includes('firefox')) {
      this.isFireFoxBrowser = true;
    }
    if (navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')) {
      document.body.classList.add('safari-browser');
    }
    if (typeof announcementBar != 'undefined' && announcementBar != null) {
      this.announcementBarHeight = announcementBar.offsetHeight;
    }
    if (typeof getHeaderSetting != 'undefined' && getHeaderSetting != null) {
      this.rawHeaderHeight = getHeaderSetting.offsetHeight;
      let headerType = getHeaderSetting.getAttribute('data-header-type');
      this.transparentHeader = getHeaderSetting.getAttribute('data-header-transparency');
      this.rawHeaderSetting = headerType;
      if (headerType == 'sticky') {
        this.headerHeight = getHeaderSetting.offsetHeight + this.announcementBarHeight;
      } else if (headerType == 'sticky-always') {
        this.headerHeight = getHeaderSetting.offsetHeight;
      } else if (headerType == 'on-scroll-up') {
      }
    }
    if (typeof gsap !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger, SplitText);
    } else {
      console.warn('GSAP is not defined');
    }
  }
  headerWithLogoAnimation(headerObjectData) {
    const headerGetData = document.querySelector('header');
    const getImageSizes = headerObjectData.querySelector('[header-logo-link]');
    const allLogoImages = getImageSizes.querySelectorAll('img');
    const originalWidth = allLogoImages[0].getAttribute('width');
    const ratioHeight = allLogoImages[0].getAttribute('height');
    const targetWidth = headerObjectData.getAttribute('data-logo-target-width');
    const scaleValueFinal = targetWidth / originalWidth;
    const topMinusHeight = ratioHeight / 2;
    const logoPosValue = headerObjectData.getAttribute('data-header-layout');
    let xPerc = 0;
    if (logoPosValue == 'header-hamburger' || logoPosValue == 'logo-center-menu-left') {
      xPerc = -50;
    }
    const bodyHeaderHeight = document.querySelector('body');
    gsap.set(allLogoImages, {
      top: `100%`,
      xPercent: xPerc,
      scale: 1,
      yPercent: 0,
      y: 0,
      force3D: true,
    });
    const headerTimeLineMove = gsap.timeline({
      scrollTrigger: {
        id: 'headerStickyAnimated',
        trigger: headerObjectData,
        start: 'top top',
        end: '150%',
        scrub: 1.5,
        invalidateOnRefresh: true,
      },
    });
    headerTimeLineMove.to(allLogoImages, {
      ease: 'power2.outIn',
      duration: 1,
      xPercent: xPerc,
      scale: scaleValueFinal,
      top: '50%',
      yPercent: 0,
      y: -topMinusHeight,
      force3D: true,
    });
  }
  bannerSlider(bannerSliderObj) {
    if (this.getBlockSizeMayaa(bannerSliderObj) > 0) {
      let heroSlideItemsContent = bannerSliderObj.querySelectorAll('[hero-slider-slide-item-content]');
      let contentHeight = bannerSliderObj.querySelector('[banner-slider-overlay-content]');
      let bannerSliderOverlay = bannerSliderObj.querySelector('[banner-slider-overlay]');
      const sectionIsAtFirst = this.firstSectionTransparentCase(
        bannerSliderObj.getAttribute('data-section-index'),
        bannerSliderObj.getAttribute('data-section'),
      );
      let contentOffSetHeight = contentHeight.getBoundingClientRect().height;
      let sliderOverlayHalfHeight = bannerSliderOverlay.getBoundingClientRect().height / 2;
      if (contentOffSetHeight < sliderOverlayHalfHeight) {
        contentOffSetHeight = sliderOverlayHalfHeight;
      }
      let offsetWrapper = bannerSliderObj.getBoundingClientRect().height;
      let marqueeVal = bannerSliderObj.querySelector('[banner-slider-marquee]');
      let lastProgressValue = null;
      gsap.set(bannerSliderOverlay, { y: offsetWrapper });
      gsap.set(bannerSliderOverlay, { '--overlay-content-height': `${contentOffSetHeight}px` });
      let scrollEndHeight = contentOffSetHeight / 2;
      let marqueeBlocks = bannerSliderObj.querySelectorAll('[marquee-text-banner-slider]');
      let mediaTextOverlay = bannerSliderObj.querySelectorAll('[data-media-icons]');
      const heroSliderBanner = gsap
        .timeline({
          ease: 'none',
          scrollTrigger: {
            id: this.scrollTriggerIdGetMayaa(bannerSliderObj),
            trigger: bannerSliderObj.closest('.section-wrapper'),
            start: 'top top+=' + (sectionIsAtFirst ? 0 : this.headerHeight),
            end: () => `+=100%`,
            pin: true,
            scrub: 1.5,
            invalidateOnRefresh: true,
            onRefresh: () => {},
          },
        })
        .to(marqueeVal, { xPercent: -15 })
        .to(heroSlideItemsContent, { opacity: 0.1 }, '<')
        .to(
          bannerSliderOverlay,
          {
            y: () => -`${scrollEndHeight}`,
            onUpdate: function () {
              const progressUpdate = Math.round(this.progress() * 100);
              if (progressUpdate !== lastProgressValue) {
                lastProgressValue = progressUpdate;
                gsap.set(bannerSliderOverlay, {
                  '--overlay-stop-value': `${progressUpdate}%`,
                });
              }
            },
          },
          '<',
        );
      const splitTextLines = bannerSliderObj.querySelector('[banner-media-text-lines]');
      if (splitTextLines != null) {
        let sliderTextAnimation = gsap.timeline({
          scrollTrigger: {
            trigger: splitTextLines,
            start: 'top 130%',
            end: 'bottom 100%',
            scrub: 1.5,
          },
        });
        const itemSplitted = new SplitText(splitTextLines, { type: 'lines' });
        sliderTextAnimation.from(itemSplitted.lines, {
          y: 50,
          opacity: 0,
          stagger: 0.05,
          duration: 0.5,
          ease: 'none',
        });
        if (mediaTextOverlay.length > 0) {
          gsap.set(mediaTextOverlay, {
            yPercent: (i) => (i % 2 == 0 ? -100 : 100),
            opacity: 0,
          });
          sliderTextAnimation.to(mediaTextOverlay, {
            yPercent: 0,
            opacity: 1,
          });
        }
      }
      this.focusTabSectionsCase(bannerSliderObj);
    }
  }
  collectionCarousel(collectionCarouselComponentObj) {
    if (this.getBlockSizeMayaa(collectionCarouselComponentObj) > 1) {
      const sectionIsAtFirstCarousel = this.firstSectionTransparentCase(
        collectionCarouselComponentObj.getAttribute('data-section-index'),
        collectionCarouselComponentObj.getAttribute('data-section'),
      );
      const collectionCarouselItem = collectionCarouselComponentObj.querySelectorAll('[collection-carousel-item]');
      const carsouelItemLength = collectionCarouselItem.length;
      let lastActiveIndexItem = -1;
      const collectionContentExtra = collectionCarouselComponentObj.querySelectorAll(
        '[collections-carousel-image-content]',
      );
      const collectionCarouselHeadingWrapper = collectionCarouselComponentObj.querySelector(
        '[collection-carousel-heading-sec]',
      );
      let manageExtraSpace = 0;
      const progressWrapperWidth = collectionCarouselComponentObj.querySelector('[collection-progress-bar-wrapper]');
      if (this.viewportWidth > progressWrapperWidth.offsetWidth) {
        manageExtraSpace = (this.viewportWidth - progressWrapperWidth.offsetWidth) / 2;
      }
      const progressEnabled = parseInt(collectionCarouselComponentObj.getAttribute('collection-slide-progress-bar'));
      if (progressEnabled == 0) {
        manageExtraSpace = 0;
      }
      const collectionProgressLine = collectionCarouselComponentObj.querySelector('[collection-progress-line]');
      const collectionHeaderSettings = collectionCarouselComponentObj.getAttribute('collection-header-sticky');
      let targetSection = collectionCarouselComponentObj.querySelector('[collection-carousel-list]');
      if (collectionHeaderSettings == '0') {
        targetSection = collectionCarouselComponentObj.querySelector('[collection-carousel-wraper]');
      }
      const extraSpaceEmpty = 50;
      const scrollWidthCollectionCarsouel = collectionCarouselComponentObj.scrollWidth;
      const endPointCalculateCollectionCarsouel = scrollWidthCollectionCarsouel - this.viewportWidth + manageExtraSpace;
      if (collectionContentExtra.length > 0) {
        gsap.set(collectionContentExtra, { autoAlpha: 0, transformPerspective: 800 });
      }
      const collectionCarouselTimeLine = gsap.timeline({
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(collectionCarouselComponentObj),
          trigger: collectionCarouselComponentObj.closest('.section-wrapper'),
          start: 'top top+=' + (sectionIsAtFirstCarousel ? 0 : this.headerHeight),
          end: `+=${endPointCalculateCollectionCarsouel + extraSpaceEmpty}`,
          pin: true,
          scrub: 1.5,
          invalidateOnRefresh: true,
          onUpdate: (self) => {
            const carsouelProgress = self.progress;
            if (collectionHeaderSettings == '1') {
              const headerSectionOffsetWidth =
                collectionCarouselHeadingWrapper.querySelector('.section-header-wrapper');
              const headerContentWidth = headerSectionOffsetWidth.offsetWidth;
              const propertyGetLive = Math.abs(gsap.getProperty(targetSection, 'x'));
              if (self.direction == 1) {
                if (propertyGetLive > headerContentWidth) {
                  collectionCarouselHeadingWrapper.classList.remove('carousel-content-visible');
                }
                if (carsouelProgress > 0.75) {
                  collectionCarouselHeadingWrapper.classList.remove('carousel-content-visible');
                }
              } else {
                if (propertyGetLive < headerContentWidth) {
                  collectionCarouselHeadingWrapper.classList.add('carousel-content-visible');
                }
                if (carsouelProgress == 1) {
                  collectionCarouselHeadingWrapper.classList.remove('carousel-content-visible');
                }
                if (carsouelProgress == 0) {
                  collectionCarouselHeadingWrapper.classList.add('carousel-content-visible');
                }
              }
            }
            const activeIndexCarsouel = Math.min(
              carsouelItemLength - 1,
              Math.floor(carsouelProgress * carsouelItemLength),
            );
            if (activeIndexCarsouel !== lastActiveIndexItem) {
              if (!collectionCarouselItem[activeIndexCarsouel].classList.contains('active-item')) {
                collectionCarouselItem[activeIndexCarsouel].classList.add('active-item');
                if (collectionContentExtra.length > 0) {
                  textContentEmoji(activeIndexCarsouel);
                }
              }
              lastActiveIndexItem = activeIndexCarsouel;
            }
          },
        },
      });
      collectionCarouselTimeLine
        .to(targetSection, {
          x: () => -endPointCalculateCollectionCarsouel,
          ease: 'none',
        })
        .to(
          collectionProgressLine,
          {
            scaleX: 1,
          },
          '<',
        );
      collectionCarouselTimeLine.add(() => {}, '+=0.05');
      function textContentEmoji(indexEmoji) {
        collectionContentExtra[indexEmoji].classList.add('active');
        gsap.to(collectionContentExtra[indexEmoji], { autoAlpha: 1 });
        const textImageData = collectionContentExtra[indexEmoji].querySelector('[collections-carousel-image-text]');
        const emojiImageData = collectionContentExtra[indexEmoji].querySelector('[collections-carousel-emoji-content]');
        const emojiTimeLine = gsap.timeline();
        const durationFirst = 0.25;
        const durationSecond = 0.5;
        if (textImageData != null) {
          emojiTimeLine.fromTo(
            textImageData,
            { y: 0, rotationX: 0, rotationZ: 0, rotationY: 0 },
            { y: -70, rotationX: 20, rotationZ: -10, rotationY: 15, ease: 'Power2.easeOut', duration: durationFirst },
          );
          emojiTimeLine.to(textImageData, {
            y: 0,
            rotationX: 0,
            rotationZ: 0,
            rotationY: 0,
            ease: 'Bounce.easeOut',
            duration: durationSecond,
          });
        }
        if (emojiImageData != null) {
          emojiTimeLine.fromTo(
            emojiImageData,
            { y: 0, rotationX: 0, rotationZ: 0, rotationY: 0 },
            { y: -70, rotationX: 20, rotationZ: -10, rotationY: 15, ease: 'Power2.easeOut', duration: durationFirst },
          );
          emojiTimeLine.to(emojiImageData, {
            y: 0,
            rotationX: 0,
            rotationZ: 0,
            rotationY: 0,
            ease: 'Bounce.easeOut',
            duration: durationSecond,
          });
        }
      }
    }
  }
  MediaCard(mediacardComponentObj) {
    const sectionIsAtFirstMedia = this.firstSectionTransparentCase(
      mediacardComponentObj.getAttribute('data-section-index'),
      mediacardComponentObj.getAttribute('data-section'),
    );
    const yTranslation = 30;
    const mediCardsAll = mediacardComponentObj.querySelectorAll('[media-card-item]');
    const endTriggerMediaCard =
      mediCardsAll[0].offsetHeight * mediCardsAll.length + (yTranslation * mediCardsAll.length - 1);
    gsap.set(mediCardsAll, {
      y: (keyM) =>
        keyM > 0 ? mediacardComponentObj.offsetHeight + yTranslation * keyM : mediacardComponentObj.offsetHeight / 3,
    });
    const timelineMediaCard = gsap.timeline({
      scrollTrigger: {
        id: this.scrollTriggerIdGetMayaa(mediacardComponentObj),
        trigger: mediacardComponentObj.closest('.section-wrapper'),
        start: 'top top+=' + (sectionIsAtFirstMedia ? 0 : this.headerHeight),
        end: `+=${endTriggerMediaCard}`,
        pin: true,
        scrub: 1.5,
        invalidateOnRefresh: true,
      },
    });
    mediCardsAll.forEach((mediCardsObj, keyMed) => {
      timelineMediaCard.to(mediCardsObj, {
        y: yTranslation * keyMed,
      });
    });
  }
  mediaWithTextSec(multipleImageWithTextComponentObj) {
    if (this.getBlockSizeMayaa(multipleImageWithTextComponentObj) > 1) {
      const leftSideMediaOverlay = multipleImageWithTextComponentObj.querySelector('[left-side-media-overlay]');
      const rightSideMediaOverlay = multipleImageWithTextComponentObj.querySelector('[right-side-media-overlay]');
      const animationType = multipleImageWithTextComponentObj.getAttribute('data-animation-type');
      gsap.set([leftSideMediaOverlay, rightSideMediaOverlay], {
        xPercent: (i) => (i === 0 ? 100 : -100),
      });
      const mediaWithText = gsap.timeline({
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(multipleImageWithTextComponentObj),
          trigger: multipleImageWithTextComponentObj.closest('.section-wrapper'),
          start: 'top+=10% bottom',
          end: 'bottom center',
          scrub: 1.5,
          invalidateOnRefresh: true,
        },
      });
      if (animationType == 'square') {
        mediaWithText.to([leftSideMediaOverlay, rightSideMediaOverlay], {
          xPercent: (i) => (i === 0 ? -15 : 15),
        });
      } else {
        mediaWithText.to([leftSideMediaOverlay, rightSideMediaOverlay], {
          xPercent: (i) => (i === 0 ? -15 : 15),
          rotateZ: (i) => (i === 0 ? -3 : 3),
        });
      }
    }
  }
  featuredBlogs(featuredBlogObj) {
    const backgroundOverlay = featuredBlogObj.querySelector('[blogs-overlay-background]');
    gsap.set(backgroundOverlay, { scaleX: 0.5, scaleY: 0.85 });
    const featureBlogTimeline = gsap.timeline({
      scrollTrigger: {
        id: this.scrollTriggerIdGetMayaa(featuredBlogObj),
        trigger: featuredBlogObj.closest('.section-wrapper'),
        start: 'top+=50% bottom',
        end: 'bottom bottom-=15%',
        scrub: 1.5,
        invalidateOnRefresh: true,
      },
    });
    featureBlogTimeline.to(backgroundOverlay, {
      scaleX: 1,
      scaleY: 1,
      borderRadius: 0,
    });
  }
  bestSellingProducts(bestSellingProductObject) {
    if (this.getBlockSizeMayaa(bestSellingProductObject) > 0) {
      const sectionIsAtFirstBestSell = this.firstSectionTransparentCase(
        bestSellingProductObject.getAttribute('data-section-index'),
        bestSellingProductObject.getAttribute('data-section'),
      );
      const rightContentArea = bestSellingProductObject.querySelector('[product-right-content-area]');
      const itemsButtonSpan = bestSellingProductObject.querySelectorAll('[product-right-title]');
      const itemsButtonSpanInner = bestSellingProductObject.querySelectorAll('[product-right-title-inner]');
      const itemInnerContent = bestSellingProductObject.querySelectorAll('[product-main-content-area]');
      const itemMediaWidth = bestSellingProductObject.querySelector('[product-list-media]');
      const itemColumnGap = bestSellingProductObject.querySelector('[product-content-left-area]');
      const columnGap = window.getComputedStyle(itemColumnGap, null).getPropertyValue('column-gap');
      const countDownSection = bestSellingProductObject.querySelector('count-down');
      let currentDirection = null;
      let lastDirectionScroll = null;
      let isCompleted = false;
      let endPointBestSelling = bestSellingProductObject.offsetHeight;
      const blockSizeGet = this.getBlockSizeMayaa(bestSellingProductObject);
      if (blockSizeGet > 2) {
        endPointBestSelling = endPointBestSelling * 1.5;
      }
      gsap.set([itemsButtonSpan, itemInnerContent], { opacity: 0 });
      gsap.set(itemsButtonSpanInner, { xPercent: -50, yPercent: -50, left: '50%' });
      gsap.set(itemsButtonSpan, {
        width: '50%',
        height: '50%',
        y: (k) => -25 + (-(k * 125) + 1),
        x: itemMediaWidth.offsetWidth + parseInt(columnGap),
        rotation: '38',
        fontSize: 30,
        opacity: 0,
        zIndex: (k) => {
          itemsButtonSpan.length - k;
        },
      });
      const timelineproduct = gsap.timeline({
        ease: 'none',
        force3d: true,
        duration: 0.2,
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(bestSellingProductObject),
          trigger: bestSellingProductObject.closest('.section-wrapper'),
          start: 'top top+=' + (sectionIsAtFirstBestSell ? 0 : this.headerHeight),
          end: `+=${endPointBestSelling}`,
          pin: true,
          scrub: 1.5,
          invalidateOnRefresh: true,
          onUpdate: (self) => {
            if (self.direction !== currentDirection) {
              currentDirection = self.direction;
              const dirScroll = currentDirection === 1 ? 'down' : 'up';
              bestSellingProductObject.setAttribute('data-scroll-direction', dirScroll);
            }
          },
        },
      });
      timelineproduct
        .to(itemsButtonSpan, {
          y: (j) => -25 + (-(j * 125) + 1),
          opacity: 0.9,
          rotation: '35',
          onStart: function () {
            rightContentArea.classList.remove('show-element');
          },
        })
        .to(itemsButtonSpan, {
          y: (j) => -25 + -((j + 1) * 125) - 15 * j,
          marginTop: '50%',
          rotation: 0,
          opacity: 1,
          width: '100%',
          height: '100%',
          x: 0,
          onStart: function () {
            gsap.set(itemInnerContent, { opacity: 0 });
          },
          onComplete: function () {
            rightContentArea.classList.add('show-element');
          },
          onUpdate: function () {
            const scrollDirCur = bestSellingProductObject.getAttribute('data-scroll-direction');
            if (scrollDirCur !== lastDirectionScroll) {
              lastDirectionScroll = scrollDirCur;
              if (scrollDirCur === 'up' && rightContentArea.classList.contains('show-element')) {
                rightContentArea.classList.remove('show-element');
              }
            }
          },
        })
        .to(itemsButtonSpan, {
          y: -25,
          marginTop: '0%',
        })
        .to(itemsButtonSpan, {
          width: '70%',
          height: '25%',
          y: 0,
          x: itemMediaWidth.offsetWidth + parseInt(columnGap),
          fontSize: 'inherit',
          onStart: function () {
            gsap.set(itemInnerContent, { opacity: 1 });
          },
          onReverseComplete: function () {
            gsap.set(itemInnerContent, { opacity: 0 });
          },
          onUpdate: function () {
            const progressPercent = this.progress() * 100;
            if (progressPercent > 75 && !isCompleted) {
              isCompleted = true;
              rightContentArea.classList.add('animation-completed');
              itemsButtonSpanInner.forEach((innerEleHeight, indexEl) => {
                const heightGetCont = innerEleHeight.getBoundingClientRect().height;
                gsap.set(itemInnerContent[indexEl], { '--best-selling-product-title-height': `${heightGetCont}px` });
              });
            } else if (progressPercent <= 75 && isCompleted) {
              isCompleted = false;
              rightContentArea.classList.remove('animation-completed');
            }
          },
        })
        .to(itemsButtonSpanInner, { xPercent: 0, left: '0%' }, '<');
      timelineproduct.add(() => {}, '+=0.05');
      if (typeof countDownSection != 'undefined' && countDownSection != null) {
        const timerSectionItem = bestSellingProductObject.querySelectorAll('.best-selling-counter-inner');
        timerSectionItem.forEach((counterItem, cIndex) => {
          counterItem.addEventListener('mousemove', (event) => {
            const boundingData = counterItem.getBoundingClientRect();
            const widthCounterSec = boundingData.width;
            const heightCounterSec = boundingData.height;
            const mouseXPos = event.clientX - boundingData.left - widthCounterSec / 2;
            const mouseYPos = event.clientY - boundingData.top - heightCounterSec / 2;
            const distanceCenter = Math.sqrt(mouseXPos ** 2 + mouseYPos ** 2);
            const maxD = Math.sqrt((widthCounterSec / 2) ** 2 + (heightCounterSec / 2) ** 2);
            const rotateXV = (mouseYPos / (heightCounterSec / 2)) * 12;
            const rotateYV = (mouseXPos / (widthCounterSec / 2)) * -12;
            const rotateZV = (distanceCenter / maxD) * 8;
            gsap.to(counterItem, {
              duration: 0.5,
              rotationY: rotateXV,
              rotationX: rotateYV,
              rotationZ: rotateZV,
              ease: 'power2.out',
            });
          });
          counterItem.addEventListener('mouseleave', () => {
            gsap.to(counterItem, { rotationY: 0, rotationX: 0, rotationZ: 0, ease: 'power2.out' });
          });
        });
      }
      this.focusTabSectionsCase(bestSellingProductObject);
    }
  }
  productsGrid(productsGridObject) {
    const sectionIsAtFirstProductGrid = this.firstSectionTransparentCase(
      productsGridObject.getAttribute('data-section-index'),
      productsGridObject.getAttribute('data-section'),
    );
    const collectionCountData = parseInt(productsGridObject.getAttribute('data-collection-count'));
    const productGridItems = productsGridObject.querySelectorAll('[products-grid-item]');
    const productGridItemss = productsGridObject.querySelectorAll('[products-grid-item]');
    const groductGridItem = productsGridObject.querySelectorAll('[products-grid-items]');
    const sectionHeader = productsGridObject.querySelector('[products-grid-header]');
    const highlightedHeader = productsGridObject.querySelector('[product-grid-overlay-heading]');
    const productGridWrapper = productsGridObject.closest('[product-grid-section-wrapper]');
    const heightThreeColumn = productsGridObject.querySelectorAll('[grid-item-three-item]');
    const heightTwoColumn = productsGridObject.querySelectorAll('[grid-item-two-item]');
    const productGridBody = productsGridObject.querySelector('[product-grid-body]');
    const extraCollectionItem = productsGridObject.querySelectorAll('[product-grid-collection-item]');
    const lineAnimationStatus = productsGridObject.getAttribute('data-line-animation');
    const svgAnimationMovingLines = productsGridObject.closest('section').querySelector('[moving-lines-animation]');
    const threeColumnHeight = productGridItems[0].offsetHeight / 2;
    const maxEndTrigger = Math.min(window.innerHeight * 3.5, 1500);
    let isGridCompleted = false;
    let marginBottom = 0;
    if (sectionHeader != null) {
      marginBottom = gsap.getProperty(sectionHeader.querySelector('.section-header'), 'marginBottom');
    }
    let paddingBottomWrapper = parseInt(heightThreeColumn[0].offsetHeight) - parseInt(productGridWrapper.offsetHeight);
    const svgLinesWidth = window.innerHeight * 2;
    paddingBottomWrapper = paddingBottomWrapper / 1.25 + threeColumnHeight;
    gsap.set(productGridWrapper, {
      paddingBottom: paddingBottomWrapper,
    });
    gsap.set(productGridItems, {
      zIndex: (i, target, targets) => (i == 5 || i == 6 ? targets.length * 2 + i : targets.length * 2 - i),
      opacity: 0,
    });
    if (lineAnimationStatus == 'true' && svgAnimationMovingLines != null) {
      gsap.set(svgAnimationMovingLines, { '--line-stroke-dashoffset-start': svgLinesWidth });
    }
    const centerOfSectionGet = productGridBody.offsetHeight / 3;
    const firstElementIntialTwoColumn = centerOfSectionGet - marginBottom;
    const secondElementIntialTwoColumn = centerOfSectionGet / 2 + marginBottom;
    const heightHalfElement = productGridItemss[0].offsetHeight / 2;
    const widthFullElement = productGridItemss[0].offsetWidth;
    const heightFullElement = productGridItemss[0].offsetHeight;
    const threeRowYArray = [
      firstElementIntialTwoColumn + heightHalfElement,
      firstElementIntialTwoColumn - heightHalfElement,
      -(secondElementIntialTwoColumn + heightHalfElement),
    ];
    const threeHighLighted = [
      firstElementIntialTwoColumn,
      -secondElementIntialTwoColumn,
      -(secondElementIntialTwoColumn + heightFullElement),
    ];
    extraCollectionItem.forEach((itemExtraColl, itemkeyColl) => {
      gsap.set(itemExtraColl, { y: window.innerHeight });
    });
    for (let i = 0; i < groductGridItem.length; i++) {
      if (i % 2 == 0) {
        let xIntialCreate = widthFullElement * 2;
        if (i == 2) {
          xIntialCreate = 0;
        }
        groductGridItem[i].querySelectorAll('[products-grid-item]').forEach((objectGridItem, objectKey) => {
          gsap.set(objectGridItem, {
            x: i > 0 ? -xIntialCreate : xIntialCreate,
            y: objectKey > 0 ? -secondElementIntialTwoColumn : firstElementIntialTwoColumn,
          });
        });
      } else {
        groductGridItem[i].querySelectorAll('[products-grid-item]').forEach((objectGridItem, objectKey) => {
          gsap.set(objectGridItem, {
            x: i == 1 ? widthFullElement : -widthFullElement,
            y: threeRowYArray[objectKey],
          });
        });
      }
    }
    const timelineProductGrid = gsap.timeline({
      scrollTrigger: {
        id: this.scrollTriggerIdGetMayaa(productsGridObject),
        trigger: productsGridObject.closest('.section-wrapper'),
        start: 'top top+=' + (sectionIsAtFirstProductGrid ? 0 : this.headerHeight),
        //end: '+=350%', - Old value long page size
        end: `+=${maxEndTrigger}`,
        scrub: 1.5,
        pin: true,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          const shouldBeActive = self.progress > 0.95;
          if (shouldBeActive && !isGridCompleted) {
            isGridCompleted = true;
            productsGridObject.classList.add('product-grid-animation-completed');
          } else if (!shouldBeActive && isGridCompleted) {
            isGridCompleted = false;
            productsGridObject.classList.remove('product-grid-animation-completed');
          }
        },
        onEnter: () => {
          if (lineAnimationStatus == 'true' && svgAnimationMovingLines != null) {
            gsap.to(svgAnimationMovingLines, {
              '--line-stroke-dashoffset-end': 0,
              duration: 2.5,
              ease: 'sine.inOut',
            });
          }
        },
      },
    });
    if (collectionCountData == 1) {
      timelineProductGrid.to(extraCollectionItem[0], {
        y: threeHighLighted[0],
        onReverseComplete: () => {
          if (lineAnimationStatus == 'true' && svgAnimationMovingLines != null) {
            gsap.to(svgAnimationMovingLines, {
              '--line-stroke-dashoffset-end': svgLinesWidth,
              duration: 2.5,
              ease: 'sine.inOut',
            });
          }
        },
        onComplete: () => {
          gsap.to(extraCollectionItem, { opacity: 0, duration: 0.5 });
          gsap.to(productGridItems, { opacity: 1, duration: 0.5 });
        },
      });
    } else if (collectionCountData == 2) {
      timelineProductGrid
        .to(extraCollectionItem[0], {
          y: threeHighLighted[0],
          onReverseComplete: () => {
            if (lineAnimationStatus == 'true' && svgAnimationMovingLines != null) {
              gsap.to(svgAnimationMovingLines, {
                '--line-stroke-dashoffset-end': svgLinesWidth,
                duration: 2.5,
                ease: 'sine.outIn',
              });
            }
          },
        })
        .to(extraCollectionItem[1], {
          y: threeHighLighted[1],
          onComplete: () => {
            gsap.to(extraCollectionItem, { opacity: 0, duration: 0.5 });
            gsap.to(productGridItems, { opacity: 1, duration: 0.5 });
          },
        });
    } else if (collectionCountData == 3) {
      timelineProductGrid
        .to(extraCollectionItem[0], {
          y: threeHighLighted[0],
          onReverseComplete: () => {
            if (lineAnimationStatus == 'true' && svgAnimationMovingLines != null) {
              gsap.to(svgAnimationMovingLines, {
                '--line-stroke-dashoffset-end': svgLinesWidth,
                duration: 2.5,
                ease: 'sine.inOut',
              });
            }
          },
        })
        .to(extraCollectionItem[1], {
          y: threeHighLighted[1],
        })
        .to(extraCollectionItem[2], {
          y: threeHighLighted[2],
          onComplete: () => {
            gsap.to(extraCollectionItem, { opacity: 0, duration: 0.5 });
            gsap.to(productGridItems, { opacity: 1, duration: 0.5 });
          },
        });
    }
    timelineProductGrid
      .to(productGridItems, {
        x: 0,
        y: 0,
        scale: 0.95,
        ease: 'sine.inOut',
        onReverseComplete: () => {
          gsap.to(productGridItems, { opacity: 0, duration: 0.5 });
          gsap.to(extraCollectionItem, { opacity: 1, duration: 0.5 });
        },
      })
      .to(
        heightTwoColumn,
        {
          top: threeColumnHeight / 2,
        },
        '<',
      )
      .to(
        heightThreeColumn,
        {
          marginTop: threeColumnHeight + marginBottom,
        },
        '<',
      )
      .to(
        sectionHeader,
        {
          opacity: 0,
        },
        '<',
      )
      .to(
        highlightedHeader,
        {
          opacity: 0,
          autoAlpha: 0,
        },
        '<',
      );
    timelineProductGrid.add(() => {}, '+=0.10');
    this.focusTabSectionsCase(productsGridObject);
  }
  videoWithTextOverlay(videoTextOverlayObj) {
    const sectionIsAtFirstVideoText = this.firstSectionTransparentCase(
      videoTextOverlayObj.getAttribute('data-section-index'),
      videoTextOverlayObj.getAttribute('data-section'),
    );
    const imageoverlayPart = videoTextOverlayObj.querySelector('[video-text-overlay-media]');
    const contentInnerOverlay = videoTextOverlayObj.querySelector('[video-text-content-inner]');
    const intialScaleImage = gsap.getProperty(imageoverlayPart, '--overlay-media-size');
    const textMarqueeWithVideo = videoTextOverlayObj.querySelector('[video-with-text-marquee]');
    const textMediaBoxElement = videoTextOverlayObj.querySelector('[video-text-radius-media]');
    const borderRadiusValueText = gsap.getProperty(textMediaBoxElement, '--card-radius');
    const endTriggerVideoOverlay = videoTextOverlayObj.offsetHeight / 1.5;
    const animationTypeVideo = videoTextOverlayObj.getAttribute('data-animation-type');
    let isScrolledOverlay = false;
    gsap.set(imageoverlayPart, { rotation: 0 });
    gsap.set(textMediaBoxElement, { borderRadius: 0 });
    if (textMarqueeWithVideo != null) {
      gsap.set(textMarqueeWithVideo, { yPercent: 100 });
    }
    let rotationDegree = 0;
    if (animationTypeVideo == 'tilt') {
      rotationDegree = -4;
    }
    const timeLineVideo = gsap.timeline({
      scrollTrigger: {
        id: this.scrollTriggerIdGetMayaa(videoTextOverlayObj),
        trigger: videoTextOverlayObj.closest('.section-wrapper'),
        start: 'top top+=' + (sectionIsAtFirstVideoText ? 0 : this.headerHeight),
        end: `+=${endTriggerVideoOverlay}`,
        pin: true,
        scrub: 1.5,
        invalidateOnRefresh: true,
      },
    });
    timeLineVideo
      .to(imageoverlayPart, {
        rotation: rotationDegree,
        scale: intialScaleImage,
        onUpdate: function () {
          const progressOverlay = this.progress();
          const shouldBeActiveOverlay = progressOverlay >= 0.5;
          if (shouldBeActiveOverlay && !isScrolledOverlay) {
            isScrolledOverlay = true;
            imageoverlayPart.classList.add('overlay-media-scrolled');
            if (contentInnerOverlay != null) {
              contentInnerOverlay.classList.add('scroll-content-active');
            }
          } else if (!shouldBeActiveOverlay && isScrolledOverlay) {
            isScrolledOverlay = false;
            imageoverlayPart.classList.remove('overlay-media-scrolled');
            if (contentInnerOverlay != null) {
              contentInnerOverlay.classList.remove('scroll-content-active');
            }
          }
        },
      })
      .to(
        textMediaBoxElement,
        {
          borderRadius: borderRadiusValueText,
        },
        '<',
      );
    if (textMarqueeWithVideo != null) {
      timeLineVideo.to(textMarqueeWithVideo, { yPercent: 0 }, '<');
    }
    this.focusTabSectionsCase(videoTextOverlayObj);
  }
  scrollableCollection(scrollableCollectionObj) {
    if (this.getBlockSizeMayaa(scrollableCollectionObj) > 0) {
      const sectionIsAtFirstScrollColl = this.firstSectionTransparentCase(
        scrollableCollectionObj.getAttribute('data-section-index'),
        scrollableCollectionObj.getAttribute('data-section'),
      );
      const animationStyleGet = scrollableCollectionObj.getAttribute('data-animation-style');
      const productScrollAboveBackground = scrollableCollectionObj.querySelector(
        '[scrollable-product-above-background]',
      );
      const scrollableFirstProduct = scrollableCollectionObj.querySelector('[scrollable-first-product]');
      const getAllScrollableItems = scrollableCollectionObj.querySelectorAll('[scrollable-collection-items]');
      const counterAnimationEnable = scrollableCollectionObj.getAttribute('data-counter-enable');
      const contentWrapperProduct = scrollableCollectionObj.querySelector('[scrollable-product-overlay-contentwrap]');
      const headerLayoutStyleSecond = scrollableCollectionObj.querySelector('[scrollabe-header-layout-wrapper]');
      const headerContentLayoutSecond = scrollableCollectionObj.querySelector('[scrollable-header-content]');
      const scrollableContentRight = scrollableCollectionObj.querySelector('[scrollable-collection-content]');
      const endtriggerScrollableCollection =
        getAllScrollableItems.length > 1
          ? this.viewportHeight * (getAllScrollableItems.length - 1)
          : this.viewportHeight;
      let counterBoxBorderradius = 0;
      let counterBoxSize = 0;
      let scaleCounter = [0, 0];
      const scrollableActiveSlideCount = scrollableCollectionObj.querySelector('[scrollabe-counter-active-slide]');
      const scrollableCounterBox = scrollableCollectionObj.querySelector('[scrollabe-counter-box]');
      if (counterAnimationEnable == 'on') {
        counterBoxBorderradius = gsap.getProperty(scrollableCounterBox, '--counter-box-radius');
        let scrollableTotalSlideNumber = scrollableCollectionObj.querySelector('[scrollabe-counter-total-slide]');
        scrollableTotalSlideNumber.innerText = '0' + getAllScrollableItems.length;
        counterBoxSize = gsap.getProperty(scrollableCounterBox, '--counter-box-size');
        const scalexDim = Math.min(counterBoxSize / this.viewportWidth);
        const scaleyDim = Math.min(counterBoxSize / this.viewportHeight);
        scaleCounter = [scalexDim, scaleyDim];
      }
      const totalTweenAnimation = getAllScrollableItems.length + 1;
      if (animationStyleGet == 'media-with-overlay') {
        gsap.set(scrollableFirstProduct, { opacity: 1 });
      } else {
        gsap.set([scrollableContentRight, getAllScrollableItems[0]], { opacity: 0 });
      }
      let flagFrame = false;
      let lastActiveSection = -1;
      let lastCounterText = '';
      const scrollableCollectionTimeline = gsap.timeline({
        ease: 'none',
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(scrollableCollectionObj),
          trigger: scrollableCollectionObj.closest('.section-wrapper'),
          start: 'top top+=' + (sectionIsAtFirstScrollColl ? 0 : this.headerHeight),
          end: `+=${endtriggerScrollableCollection}`,
          scrub: true,
          pin: true,
          invalidateOnRefresh: true,
          onUpdate: (self) => {
            if (!flagFrame) {
              flagFrame = true;
              requestAnimationFrame(() => {
                handleScrollUpdateCollection(self);
                flagFrame = false;
              });
            }
          },
        },
      });
      if (animationStyleGet == 'media-with-overlay') {
        scrollableCollectionTimeline
          .to([productScrollAboveBackground, contentWrapperProduct], { yPercent: -100, rotate: -14 })
          .fromTo(
            scrollableFirstProduct,
            { scaleX: 1, scaleY: 1 },
            {
              scaleX: scaleCounter[0],
              scaleY: scaleCounter[1],
              borderRadius: counterBoxBorderradius * 5 + counterBoxBorderradius / 2,
              onComplete: () => {
                if (counterAnimationEnable == 'on') {
                  gsap.set(scrollableFirstProduct, { opacity: 0 });
                  gsap.set(scrollableCounterBox, { '--counter-box-opacity': 1 });
                }
              },
            },
          );
        scrollableCollectionTimeline.fromTo(
          getAllScrollableItems[0],
          { '--scrollable-media-clip': '0%', '--scrollable-media-zoom': 1.2, zIndex: 0 },
          {
            '--scrollable-media-clip': '0%',
            '--scrollable-media-zoom': 1,
            onStart() {
              gsap.to(this.targets()[0], { zIndex: 1 });
            },
          },
          '<',
        );
      } else {
        scrollableCollectionTimeline
          .to(headerLayoutStyleSecond, { opacity: 0 })
          .to(headerContentLayoutSecond, { scale: 0.8, opacity: 0 }, '<');
        scrollableCollectionTimeline.fromTo(scrollableContentRight, { opacity: 0 }, { opacity: 1 }, '<').fromTo(
          getAllScrollableItems[0],
          { '--scrollable-media-clip': '0%', '--scrollable-media-zoom': 1.2, opacity: 0, zIndex: 0 },
          {
            '--scrollable-media-clip': '0%',
            '--scrollable-media-zoom': 1,
            opacity: 1,
            onStart() {
              gsap.to(this.targets()[0], { zIndex: 1 });
              headerLayoutStyleSecond.classList.add('scrollable-text-fade-out');
            },
            onReverseComplete() {
              headerLayoutStyleSecond.classList.remove('scrollable-text-fade-out');
            },
          },
          '<',
        );
      }
      if (getAllScrollableItems.length > 1) {
        getAllScrollableItems.forEach((scrollItem, scrollKey) => {
          if (scrollKey > 0) {
            scrollableCollectionTimeline.fromTo(
              scrollItem,
              { '--scrollable-media-clip': '100%', '--scrollable-media-zoom': 1.2, zIndex: 0 },
              {
                '--scrollable-media-clip': '0%',
                '--scrollable-media-zoom': 1,
                onStart() {
                  gsap.to(this.targets()[0], { zIndex: scrollKey + 1 });
                },
              },
            );
          }
        });
      }
      this.focusTabSectionsCase(scrollableCollectionObj);
      function handleScrollUpdateCollection(self) {
        if (counterAnimationEnable !== 'on') return;
        const progress = self.progress;
        const direction = self.direction;
        const activeState =
          animationStyleGet === 'media-with-overlay'
            ? Math.floor(progress * totalTweenAnimation)
            : Math.floor(progress * getAllScrollableItems.length);

        const isForward = direction === 1;
        function updateCounterText(newText) {
          if (newText !== lastCounterText) {
            scrollableActiveSlideCount.innerText = newText;
            lastCounterText = newText;
          }
        }
        if (activeState !== lastActiveSection) {
          lastActiveSection = activeState;
        }
        if (animationStyleGet === 'media-with-overlay') {
          if (isForward) {
            if (activeState > 1 && activeState <= getAllScrollableItems.length) {
              const mediaClip = +gsap
                .getProperty(getAllScrollableItems[activeState - 1], '--scrollable-media-clip')
                .toFixed(2);
              if (mediaClip > 49 && mediaClip < 55) {
                updateCounterText(getAllScrollableItems[activeState - 1].getAttribute('scrollable-item-count'));
              }
            }
            if (activeState === 1) {
              const tween = scrollableCollectionTimeline.getChildren()[1];
              const tweenProgress = tween.progress();
              if (tweenProgress > 0.75) {
                gsap.set(scrollableFirstProduct, { opacity: Math.max(0, 1 - (tweenProgress - 0.75) / 0.25) });
                gsap.set(scrollableCounterBox, { '--counter-box-opacity': Math.min(1, (tweenProgress - 0.75) / 0.25) });
              } else {
                gsap.set(scrollableCounterBox, { '--counter-box-opacity': 0 });
                gsap.set(scrollableFirstProduct, { opacity: 1 });
              }
            }
            if (progress === 1) {
              gsap.set(scrollableFirstProduct, { opacity: 0 });
              gsap.set(scrollableCounterBox, { '--counter-box-opacity': 1 });
              updateCounterText(`0${activeState - 1}`);
            }
          } else {
            if (activeState > 1) {
              const mediaClip = +gsap
                .getProperty(getAllScrollableItems[activeState - 1], '--scrollable-media-clip')
                .toFixed(2);
              if (mediaClip > 50) {
                updateCounterText(`0${activeState - 1}`);
              }
            }
            if (activeState === 1) {
              const tween = scrollableCollectionTimeline.getChildren()[1];
              const tweenProgress = tween.progress();
              if (tweenProgress >= 0.75 && tweenProgress <= 1) {
                gsap.set(scrollableFirstProduct, { opacity: Math.min(1, (1 - tweenProgress) / 0.25) });
                gsap.set(scrollableCounterBox, { '--counter-box-opacity': Math.max(0, (tweenProgress - 0.75) / 0.25) });
              } else {
                gsap.set(scrollableFirstProduct, { opacity: 1 });
                gsap.set(scrollableCounterBox, { '--counter-box-opacity': 0 });
              }
            }
            if (progress === 1) {
              gsap.set(scrollableFirstProduct, { opacity: 0 });
              gsap.set(scrollableCounterBox, { '--counter-box-opacity': 1 });
              updateCounterText(`0${activeState - 1}`);
            }
          }
        } else {
          if (isForward) {
            if (activeState === 0) {
              const tween = scrollableCollectionTimeline.getChildren()[0];
              const tweenProgress = tween.progress();
              gsap.set(scrollableCounterBox, { '--counter-box-opacity': tweenProgress > 0.7 ? 1 : 0 });
            }
            if (activeState > 0 && activeState < getAllScrollableItems.length) {
              const mediaClip = +gsap
                .getProperty(getAllScrollableItems[activeState], '--scrollable-media-clip')
                .toFixed(2);
              if (mediaClip > 49 && mediaClip < 55) {
                updateCounterText(getAllScrollableItems[activeState].getAttribute('scrollable-item-count'));
              }
            }
            if (progress === 1) {
              gsap.set(scrollableCounterBox, { '--counter-box-opacity': 1 });
              updateCounterText(`0${activeState}`);
            }
          } else {
            if (activeState === 0) {
              gsap.set(scrollableCounterBox, { '--counter-box-opacity': 0 });
            }
            if (activeState > 0) {
              const mediaClip = +gsap
                .getProperty(getAllScrollableItems[activeState], '--scrollable-media-clip')
                .toFixed(2);
              if (mediaClip > 50) {
                updateCounterText(`0${activeState}`);
              }
            }
            if (progress === 1) {
              gsap.set(scrollableCounterBox, { '--counter-box-opacity': 1 });
              updateCounterText(`0${activeState}`);
            }
          }
        }
      }
    }
  }
  featuredProductSecondaryView(featuredProductObj) {
    const featureProductVariantVersion = featuredProductObj.getAttribute('variantFeatureVersion');
    if (featureProductVariantVersion == 'V2') {
      const animationStyleData = this.getSectionAnimationStyle(featuredProductObj);
      if (animationStyleData == 'none') {
        return false;
      }
      const sectionIsAtFirstFeaturePro = this.firstSectionTransparentCase(
        featuredProductObj.getAttribute('data-section-index'),
        featuredProductObj.getAttribute('data-section'),
      );
      const headerPartFeatureProduct = featuredProductObj.querySelector('[feature-product-header]');
      const featureProductLeftPart = featuredProductObj.querySelectorAll('[feature-product-left-part]');
      const featureProductRightPart = featuredProductObj.querySelectorAll('[feature-product-right-part]');
      const featureMainThumbSec = featuredProductObj.querySelector('[feature-product-thumb-main]');
      const featureThumbItems = featuredProductObj.querySelectorAll('[thumb-feature-product-item]');
      const featureProductMainWrapper = featuredProductObj.querySelector('[feature-product-main-wrapper]');
      if (featureProductLeftPart != null) {
        gsap.set(featureProductLeftPart, { xPercent: -125 });
      }
      if (featureProductRightPart != null) {
        gsap.set(featureProductRightPart, { xPercent: 125 });
      }
      if (featureMainThumbSec != null) {
        gsap.set([featureMainThumbSec, featureThumbItems], { scale: 0 });
      }
      const featureProductTimeline = gsap.timeline({
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(featuredProductObj),
          trigger: featuredProductObj,
          start: 'top top+=' + (sectionIsAtFirstFeaturePro ? 0 : this.headerHeight),
          end: `+=100%`,
          scrub: true,
          pin: true,
          invalidateOnRefresh: true,
          onEnter: () => {
            gsap.to(featureProductMainWrapper, { yPercent: -100, duration: 0.8, ease: 'power4.inOut' });
            if (featureProductLeftPart != null) {
              if (featureProductLeftPart != null && featureProductRightPart != null) {
                if (this.isFireFoxBrowser) {
                  gsap.to([featureProductLeftPart, featureProductRightPart], {
                    xPercent: 0,
                    duration: 0.8,
                    ease: 'power2.outIn',
                  });
                } else {
                  gsap.to([featureProductLeftPart, featureProductRightPart], {
                    xPercent: 0,
                    duration: 0.8,
                    stagger: { amount: 0.2, from: 'start', ease: 'power2.outIn' },
                  });
                }
              } else {
                if (this.isFireFoxBrowser) {
                  gsap.to(featureProductLeftPart, { xPercent: 0, duration: 0.8 });
                } else {
                  gsap.to(featureProductLeftPart, {
                    xPercent: 0,
                    duration: 0.8,
                    ease: 'power2.outIn',
                    stagger: { amount: 0.2, from: 'start', ease: 'power2.outIn' },
                  });
                }
              }
            } else {
              if (featureProductRightPart != null) {
                if (this.isFireFoxBrowser) {
                  gsap.to(featureProductRightPart, { xPercent: 0, duration: 0.8 });
                } else {
                  gsap.to(featureProductRightPart, {
                    xPercent: 0,
                    duration: 0.8,
                    stagger: { amount: 0.2, from: 'start', ease: 'power2.outIn' },
                  });
                }
              }
            }
            if (featureMainThumbSec != null) {
              gsap.to([featureMainThumbSec, featureThumbItems], { scale: 1.01, ease: 'power4.inOut' });
            }
          },
          onLeaveBack: () => {
            const getDirectionScroll = document.body.getAttribute('data-scroll-direction');
            if (getDirectionScroll == 'up') {
              if (featureProductLeftPart != null) {
                if (featureProductLeftPart != null && featureProductRightPart != null) {
                  if (this.isFireFoxBrowser) {
                    gsap.to(featureProductLeftPart, { xPercent: -125, duration: 0.8 });
                    gsap.to(featureProductRightPart, { xPercent: 125, duration: 0.8 });
                  } else {
                    gsap.to(featureProductLeftPart, {
                      xPercent: -125,
                      duration: 0.8,
                      stagger: { amount: 0.2, from: 'start', ease: 'power2.inOut' },
                    });
                    gsap.to(featureProductRightPart, {
                      xPercent: 125,
                      duration: 0.8,
                      stagger: { amount: 0.2, from: 'start', ease: 'power2.inOut' },
                    });
                  }
                } else {
                  if (this.isFireFoxBrowser) {
                    gsap.to(featureProductLeftPart, { xPercent: -125, duration: 0.8 });
                  } else {
                    gsap.to(featureProductLeftPart, {
                      xPercent: -125,
                      duration: 0.8,
                      stagger: { amount: 0.2, from: 'start', ease: 'power2.inOut' },
                    });
                  }
                }
              } else {
                if (featureProductRightPart != null) {
                  if (this.isFireFoxBrowser) {
                    gsap.to(featureProductRightPart, { xPercent: 125, duration: 0.8 });
                  } else {
                    gsap.to(featureProductRightPart, {
                      xPercent: 125,
                      duration: 0.8,
                      stagger: { amount: 0.2, from: 'start', ease: 'power2.inOut' },
                    });
                  }
                }
              }
              if (featureMainThumbSec != null) {
                gsap.to([featureMainThumbSec, featureThumbItems], { scale: 0 });
              }
              gsap.to(featureProductMainWrapper, { yPercent: 0, duration: 0.8, ease: 'power4.inOut' });
            }
          },
        },
      });
      this.focusTabSectionsCase(featuredProductObj);
    }
  }
  verticalCarousel(verticalCarouselObj) {
    const blocSizeData = this.getBlockSizeMayaa(verticalCarouselObj);
    if (blocSizeData < 3) {
      return false;
    }
    const sectionIsAtFirstFeatureVertical = this.firstSectionTransparentCase(
      verticalCarouselObj.getAttribute('data-section-index'),
      verticalCarouselObj.getAttribute('data-section'),
    );
    const circleElement = verticalCarouselObj.querySelector('[vertical-circle-rotate]');
    const allItemVertical = verticalCarouselObj.querySelectorAll('[vertical-circle-item]');
    const itemContentAll = verticalCarouselObj.querySelectorAll('[vertical-circle-content]');
    const itemInnerContentAll = verticalCarouselObj.querySelectorAll('[vc-inner-content]');
    const itemContentHeader = verticalCarouselObj.querySelector('[verticle-circle-header]');
    const animationOnContent = verticalCarouselObj.getAttribute('data-animation-type');
    const rightSideSectionVc = verticalCarouselObj.querySelector('[vertical-right-section-main]');
    gsap.set(rightSideSectionVc, { '--slide-card-width': `${rightSideSectionVc.offsetWidth}px` });
    const cardItemCount = allItemVertical.length;
    const currentIndexSl = 0;
    const widthElement = allItemVertical[0].getBoundingClientRect().width;
    const cardRadiusData = gsap.getProperty(allItemVertical[0], 'borderRadius');
    let diameterGetForCircle = calculateCircleDiameter(widthElement, cardItemCount);
    const calculateAngleForEachitem = (2 * Math.PI) / cardItemCount;
    const angleInDegree = radiansToDegrees(calculateAngleForEachitem);
    diameterGetForCircle = diameterGetForCircle.toFixed(2);
    let radiusOfCircleDiameter = diameterGetForCircle / 2;
    radiusOfCircleDiameter = radiusOfCircleDiameter.toFixed(2);
    const timelineRotateZ = 360 - angleInDegree;
    const startingAngle = -angleInDegree;
    const arrayNewDown = [];
    const arrayNewUp = [];
    for (let iv = 0; iv < allItemVertical.length; iv++) {
      let createaa = startingAngle + angleInDegree * iv;
      if (iv > 0) {
        arrayNewDown.push(Math.round(createaa - 10));
        arrayNewUp.push(Math.round(createaa + 10));
      }
    }
    arrayNewDown.push(Math.round(timelineRotateZ));
    arrayNewUp.push(Math.round(timelineRotateZ));
    let baseGap = 90;
    const halfGapBase = baseGap / 2;
    if (cardRadiusData > 0) {
      baseGap = cardRadiusData > baseGap ? cardRadiusData - baseGap : baseGap - cardRadiusData;
      if (baseGap < halfGapBase) {
        baseGap = halfGapBase;
      }
    }
    if (cardItemCount > 4) {
      baseGap = 150;
      if (cardRadiusData > 0) {
        baseGap = baseGap - cardRadiusData;
      }
    }
    radiusOfCircleDiameter = parseInt(radiusOfCircleDiameter) + baseGap;
    gsap.set(allItemVertical, { opacity: 0 });
    gsap.set(allItemVertical[0], { opacity: 1 });
    gsap.set(circleElement, {
      width: diameterGetForCircle,
      height: diameterGetForCircle,
      rotateZ: itemContentHeader != null ? -angleInDegree : 0,
    });
    if (itemContentHeader == null) {
      itemContentAll[0].classList.add('active');
      itemInnerContentAll[0].classList.add(animationOnContent);
    }
    const itemStatedFrom = 180;
    allItemVertical.forEach((item, index) => {
      let angleValueRadian = calculateAngleForEachitem * index;
      angleValueRadian = angleValueRadian * -1;
      const angleTranslate = itemStatedFrom - index * angleInDegree;
      const radianValueTranslation = degreesToRadians(angleTranslate);
      const xTranslate = radiusOfCircleDiameter * Math.cos(radianValueTranslation);
      const yTranslate = radiusOfCircleDiameter * Math.sin(radianValueTranslation);
      gsap.set(item, {
        xPercent: -50,
        yPercent: -50,
        x: xTranslate,
        y: yTranslate,
        rotation: `${angleValueRadian}_rad`,
      });
    });
    const circleRotate = gsap.timeline({
      ease: 'none',
      scrollTrigger: {
        id: this.scrollTriggerIdGetMayaa(verticalCarouselObj),
        trigger: verticalCarouselObj.closest('.section-wrapper'),
        start: 'top top+=' + (sectionIsAtFirstFeatureVertical ? 0 : this.headerHeight),
        end: `+=${diameterGetForCircle * 2}`,
        pin: true,
        scrub: true,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          const rotatezVc = gsap.getProperty(circleElement, 'rotateZ');
          if (self.direction === 1) {
            const currentSlideNumber = getIndexDataDownScroll(rotatezVc, arrayNewDown);
            if (currentSlideNumber !== null && currentSlideNumber >= 0) {
              if (itemContentHeader !== null) {
                itemContentHeader.classList.remove('active');
                itemContentHeader.querySelector('.vertical-carousel-header-inner').classList.remove(animationOnContent);
              }
              circleElement.classList.add('border');
              if (!itemContentAll[currentSlideNumber].classList.contains('active')) {
                const thumbProductWrapper =
                  itemContentAll[currentSlideNumber].querySelectorAll('[thumb-product-wrapper]');
                if (thumbProductWrapper != null && thumbProductWrapper.length > 0) {
                  const thumbProductContent =
                    itemContentAll[currentSlideNumber].querySelectorAll('[thumb-product-content]');
                  thumbProductWrapper[currentIndexSl].classList.add('active');
                }
                removeActiveClassContent(itemContentAll, 'active');
                removeActiveClassContent(itemInnerContentAll, animationOnContent);
                itemContentAll[currentSlideNumber].classList.add('active');
                itemInnerContentAll[currentSlideNumber].classList.add(animationOnContent);
              }
              if (!allItemVertical[currentSlideNumber].classList.contains('active')) {
                removeActiveCardItem(allItemVertical);
                gsap.set(allItemVertical[currentSlideNumber], { opacity: 1 });
                allItemVertical[currentSlideNumber].classList.add('active');
              }
              if (currentSlideNumber < allItemVertical.length - 1) {
                gsap.set(allItemVertical[currentSlideNumber + 1], { opacity: 1 });
              }
              if (currentSlideNumber == allItemVertical.length - 1) {
                gsap.set(allItemVertical[0], { opacity: 0 });
              }
            } else {
              removeActiveClassContent(itemContentAll, 'active');
              removeActiveClassContent(itemInnerContentAll, animationOnContent);
              removeActiveCardItem(allItemVertical);
              if (itemContentHeader !== null) {
                itemContentHeader.classList.add('active');
                itemContentHeader.querySelector('.vertical-carousel-header-inner').classList.add(animationOnContent);
              }
              circleElement.classList.remove('border');
            }
          } else {
            const currentSlideNumber = getIndexDataUpScroll(rotatezVc, arrayNewUp, angleInDegree);
            if (currentSlideNumber !== null && currentSlideNumber >= 0) {
              if (itemContentHeader !== null) {
                itemContentHeader.classList.remove('active');
                itemContentHeader.querySelector('.vertical-carousel-header-inner').classList.remove(animationOnContent);
              }
              circleElement.classList.add('border');
              if (!itemContentAll[currentSlideNumber].classList.contains('active')) {
                const thumbProductWrapper =
                  itemContentAll[currentSlideNumber].querySelectorAll('[thumb-product-wrapper]');
                if (thumbProductWrapper != null && thumbProductWrapper.length > 0) {
                  const thumbProductContent =
                    itemContentAll[currentSlideNumber].querySelectorAll('[thumb-product-content]');
                  thumbProductWrapper[currentIndexSl].classList.add('active');
                }

                removeActiveClassContent(itemContentAll, 'active');
                removeActiveClassContent(itemInnerContentAll, animationOnContent);
                itemContentAll[currentSlideNumber].classList.add('active');
                itemInnerContentAll[currentSlideNumber].classList.add(animationOnContent);
              }
              if (!allItemVertical[currentSlideNumber].classList.contains('active')) {
                removeActiveCardItem(allItemVertical);
                gsap.set(allItemVertical[currentSlideNumber], { opacity: 1 });
                allItemVertical[currentSlideNumber].classList.add('active');
              }
              if (currentSlideNumber < allItemVertical.length && currentSlideNumber > 0) {
                gsap.set(allItemVertical[currentSlideNumber - 1], { opacity: 1 });
              }
              if (currentSlideNumber == 0) {
                gsap.set(allItemVertical, { opacity: 0 });
                gsap.set(allItemVertical[currentSlideNumber], { opacity: 1 });
                gsap.set(allItemVertical[currentSlideNumber + 1], { opacity: 1 });
              }
            } else {
              removeActiveClassContent(itemContentAll, 'active');
              removeActiveClassContent(itemInnerContentAll, animationOnContent);
              removeActiveCardItem(allItemVertical);
              if (itemContentHeader !== null) {
                itemContentHeader.classList.add('active');
                itemContentHeader.querySelector('.vertical-carousel-header-inner').classList.add(animationOnContent);
              }
              circleElement.classList.remove('border');
            }
          }
        },
      },
    });
    circleRotate.to(circleElement, {
      rotateZ: timelineRotateZ,
      ease: 'none',
      duration: 1,
    });
    circleRotate.add(() => {}, '+=0.08');
    function radiansToDegrees(radians) {
      return radians * (180 / Math.PI);
    }
    function degreesToRadians(degrees) {
      return degrees * (Math.PI / 180);
    }
    function calculateCircleDiameter(cardWidth, cardCount) {
      const extraDiameter = cardCount > 4 ? cardWidth / 2 : cardWidth;
      const circumference = cardWidth * cardCount + extraDiameter;
      const radius = circumference / (2 * Math.PI);
      return 2 * radius;
    }
    function removeActiveClassContent(elementAll, classRemove) {
      elementAll.forEach((elem, key) => {
        elem.classList.remove(classRemove);
      });
    }
    function removeActiveCardItem(elementAll) {
      elementAll.forEach((elem, key) => {
        elem.classList.remove('active');
      });
    }
    function getIndexDataDownScroll(valueZ, array) {
      for (let i = 0; i < array.length - 1; i++) {
        if (valueZ >= array[i] && valueZ < array[i + 1]) {
          return i;
        }
      }
      if (valueZ === array[array.length - 1]) {
        return array.length - 1;
      }
      return null;
    }
    function getIndexDataUpScroll(valueZ, array, angleH) {
      const halfAngleCal = angleH / 2;
      if (valueZ > -halfAngleCal) {
        for (let i = array.length - 1; i >= 0; i--) {
          if (valueZ <= array[i] && valueZ > (array[i - 1] || -Infinity)) {
            return i;
          }
        }
      }
      return null;
    }
    this.focusTabSectionsCase(verticalCarouselObj);
  }
  featuredCollectionStacked(fcStackedObj) {
    let animationOnce = false;
    const animationTypeGet = fcStackedObj.getAttribute('animation-type');
    if (animationTypeGet == 'once') {
      animationOnce = true;
    }
    const getAllItemFeatureCollection = fcStackedObj.querySelectorAll('[data-collection-product-item]');
    let getColumnCountWrapper = fcStackedObj.querySelector('[data-column-count]').getAttribute('data-column-count');
    gsap.set(fcStackedObj, { '--fetaureItemCount': getAllItemFeatureCollection.length });
    getColumnCountWrapper = getColumnCountWrapper - 1;
    let counterSet = 0;
    let rowCounter = 1;
    ScrollTrigger.batch(getAllItemFeatureCollection, {
      once: animationOnce,
      invalidateOnRefresh: true,
      onEnter: (batch) => {
        batch.forEach((elementItemFeatured) => {
          if (animationTypeGet === 'repeat') {
            elementItemFeatured.classList.remove('slide-out-top', 'slide-in-top');
          }
          elementItemFeatured.classList.add('slide-in-bottom');
        });
      },
      onLeave: (batch) => {
        batch.forEach((elementItemFeatured) => {
          if (animationTypeGet === 'repeat') {
            elementItemFeatured.classList.remove('slide-in-bottom', 'slide-in-top');
            elementItemFeatured.classList.add('slide-out-top');
          }
        });
      },
      onEnterBack: (batch) => {
        batch.forEach((elementItemFeatured) => {
          if (animationTypeGet === 'repeat') {
            elementItemFeatured.classList.remove('slide-in-bottom', 'slide-out-top');
            elementItemFeatured.classList.add('slide-in-top');
          }
        });
      },
      onLeaveBack: (batch) => {
        batch.forEach((elementItemFeatured) => {
          if (animationTypeGet === 'repeat') {
            elementItemFeatured.classList.remove('slide-out-top', 'slide-in-top', 'slide-in-bottom');
          }
        });
      },
    });
    getAllItemFeatureCollection.forEach((elementItemFeatured, index) => {
      gsap.set(elementItemFeatured, { '--indexFeatureItem': counterSet });
      counterSet++;
      if (counterSet > parseInt(getColumnCountWrapper)) {
        counterSet = 0;
        rowCounter++;
      }
    });
  }
  scrollableMarquee(scrollableMarqObj) {
    const animationType = scrollableMarqObj.getAttribute('data-animation-type');
    const animationStyle = scrollableMarqObj.getAttribute('data-animation-style');
    if (animationType == 'marquee') {
      const sectionIsAtFirstMarquee = this.firstSectionTransparentCase(
        scrollableMarqObj.getAttribute('data-section-index'),
        scrollableMarqObj.getAttribute('data-section'),
      );
      if (animationStyle == 'none') {
        const radiusStart = 120;
        const imageScrollableMarqueeWrapper = scrollableMarqObj.querySelector('[scrollable-marquee-image-wrapper]');
        if(imageScrollableMarqueeWrapper){
        const imageScrollableMarquee = imageScrollableMarqueeWrapper.querySelector('img');
        if (imageScrollableMarquee) {
          //gsap.set(imageScrollableMarquee,{scale:0.5,transformOrigin: "center center",yPercent:-30});
          gsap.set(imageScrollableMarquee, {
            scale: 0.5,
            x: 0,
            y: -80,
            transformOrigin: 'center center',
            willChange: 'transform',
            force3D: true,
          });
          const marqueeSquareTimeline = gsap.timeline({
            scrollTrigger: {
              id: this.scrollTriggerIdGetMayaa(scrollableMarqObj),
              trigger: scrollableMarqObj.closest('.section-wrapper'),
              start: 'top 80%',
              toggleActions: 'play none none none',
              once: true,
            },
          });
          marqueeSquareTimeline.to(imageScrollableMarquee, {
            scale: 1,
            rotation: 360,
            duration: 2,
            ease: 'power2.out',
            onUpdate: function () {
              const progressTimeline = this.progress();
              const angle = progressTimeline * Math.PI * 2;
              const radius = radiusStart * (1 - progressTimeline);
              gsap.set(imageScrollableMarquee, {
                x: Math.cos(angle) * radius,
                y: Math.sin(angle) * radius,
              });
            },
          });
          //marqueeSquareTimeline.to(imageScrollableMarquee,{scale:1,ease: "power2.out",yPercent:0,duration:2})

          //marqueeSquareTimeline.to(imageScrollableMarquee,{scale:0.5,transformOrigin: "center center",yPercent:-30}).to(imageScrollableMarquee,{scale:1,ease: "power2.out",yPercent:0,duration:2})

          //marqueeSquareTimeline.fromTo(imageScrollableMarquee,{rotation: 0,scale:0.5,transformOrigin: "center center"},{rotation:360,ease: "power2.out", scale:1,duration:2})
        }
        }
      } else {
        const imageAnimationType = scrollableMarqObj.getAttribute('data-animation-image-style');
        const scaledSectionMarquee = scrollableMarqObj.querySelector('[scrollable-marquee-scale]');
        const scrollableWrapperInner = scrollableMarqObj.querySelector('[scrollable-marquee-inner]');
        const scrollableMarqueeEvenRow = scrollableMarqObj.querySelectorAll('[scrollable-marquee-even-row]');
        const scrollDirectionEven = scrollableMarqueeEvenRow[0].getAttribute('data-direction');
        const scrollableMarqueeOddRow = scrollableMarqObj.querySelectorAll('[scrollable-marquee-odd-row]');
        const scrollDirectionOdd = scrollableMarqueeOddRow[0].getAttribute('data-direction');
        const endTriggerMarq = Math.min(window.innerHeight * 2, 1500);
        let mediaVisible = false;
        let clipPathfrom = 'circle(0% at 50% 50%)';
        let clipPathTo = 'circle(100% at 50% 50%)';
        if (scaledSectionMarquee != null) {
          if (imageAnimationType == 'square') {
            clipPathfrom = 'inset(100%)';
            clipPathTo = 'inset(0%)';
          }
          gsap.set(scaledSectionMarquee, { clipPath: `${clipPathfrom}` });
        }
        const scaleTimeline = gsap.timeline({
          scrollTrigger: {
            id: this.scrollTriggerIdGetMayaa(scrollableMarqObj),
            trigger: scrollableMarqObj.closest('.section-wrapper'),
            start: 'top top+=' + (sectionIsAtFirstMarquee ? 0 : this.headerHeight),
            end: `+=${endTriggerMarq}`,
            pin: true,
            scrub: 1.5,
            invalidateOnRefresh: true,
          },
        });
        scaleTimeline
          .to(scrollableMarqueeOddRow, {
            xPercent: scrollDirectionOdd == 'ltr' ? 15 : -15,
          })
          .to(
            scrollableMarqueeEvenRow,
            {
              xPercent: scrollDirectionEven == 'ltr' ? 15 : -15,
            },
            '<',
          );
        if (scaledSectionMarquee != null) {
          let cmpProg = 65;
          if (imageAnimationType == 'square') {
            cmpProg = 80;
          }
          scaleTimeline.to(scaledSectionMarquee, {
            clipPath: `${clipPathTo}`,
            onUpdate: function () {
              const progressPercent = Math.round(this.progress() * 100);
              const shouldBeVisible = progressPercent > cmpProg;
              if (shouldBeVisible && !mediaVisible) {
                mediaVisible = true;
                scrollableMarqObj.classList.add('media-visible');
              } else if (!shouldBeVisible && mediaVisible) {
                mediaVisible = false;
                scrollableMarqObj.classList.remove('media-visible');
              }
            },
          });
        }
      }
      this.focusTabSectionsCase(scrollableMarqObj);
    }
  }
  richText(richTextObj) {
    if (this.getBlockSizeMayaa(richTextObj) > 0) {
      const animationStyleData = this.getSectionAnimationStyle(richTextObj);
      if (animationStyleData == 'none') {
        return false;
      }
      const sectionIsAtFirstRich = this.firstSectionTransparentCase(
        richTextObj.getAttribute('data-section-index'),
        richTextObj.getAttribute('data-section'),
      );
      const mainWrapperRichText = richTextObj.querySelector('[rich-text-wrapper]');
      const getAnimationType = richTextObj.getAttribute('data-animation-type');
      const richTextAnimatedColor = richTextObj.querySelector('[rich-animated-color]');
      const richTextCollectionItem = richTextObj.querySelectorAll('[rich-text-collection-item]');
      const richTextCollectionItemCenter = richTextObj.querySelector('[rich-text-collection-item-center]');
      const withoutCenterCollectionItem = richTextObj.querySelectorAll(
        '[rich-text-collection-item]:not([rich-text-collection-item-center])',
      );
      //gsap.set(richTextObj,{"--text-reveal-percentage":"100%"})
      let pinState = false;
      let hasAnimatedBack = false;
      const arrayIntialValueAll = [];
      let fullCordinateArray = [];
      if (getAnimationType == 'color-based') {
        gsap.set(richTextAnimatedColor, {
          scale: 15,
        });
        pinState = true;
        if (richTextCollectionItem.length > 0) {
          let marginRightValue = 0;
          let borderWidthValue = 0;
          const intialXValue = richTextCollectionItemCenter.getBoundingClientRect();
          richTextCollectionItem.forEach((richTextItems, indexKeyText) => {
            if (!richTextItems.hasAttribute('rich-text-collection-item-center')) {
              if (richTextItems.getBoundingClientRect().x > intialXValue.x) {
                const rightValueX = richTextItems.getBoundingClientRect().x - intialXValue.x;
                const addMarginRightSide = gsap.getProperty(richTextItems, 'marginLeft');
                const borderRightValue = gsap.getProperty(richTextItems, 'border-width');
                const makePostiveValue = Math.abs(addMarginRightSide);
                marginRightValue = marginRightValue + makePostiveValue;
                borderWidthValue = borderWidthValue + parseInt(borderRightValue);
                arrayIntialValueAll.push(-(rightValueX - marginRightValue));
              }
            }
          });
          const makeleftPostiveArray = [...arrayIntialValueAll].reverse().map(Math.abs);
          fullCordinateArray = [...makeleftPostiveArray, ...arrayIntialValueAll];
          gsap.to(withoutCenterCollectionItem, { x: (i) => fullCordinateArray[i] });
        }
      }
      const timelineRichText = gsap.timeline({
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(richTextObj),
          trigger: richTextObj.closest('.section-wrapper'),
          start:
            getAnimationType == 'color-based'
              ? 'top top+=' + (sectionIsAtFirstRich ? 0 : this.headerHeight)
              : 'top 25%',
          end: `+=125%`,
          scrub: 1.5,
          pin: pinState,
          invalidateOnRefresh: true,
          onEnter: () => {
            mainWrapperRichText.classList.add('in-visible-state');
          },
          onLeave: () => {
            mainWrapperRichText.classList.remove('in-visible-state');
          },
          onEnterBack: () => {
            mainWrapperRichText.classList.add('in-visible-state');
          },
          onLeaveBack: () => {
            mainWrapperRichText.classList.remove('in-visible-state');
          },
          onUpdate: (self) => {
            if (getAnimationType == 'color-based') {
              if (richTextCollectionItem.length > 0) {
                const progressTimeline = Math.round(self.progress * 100);
                if (self.direction === -1 && progressTimeline < 85 && !hasAnimatedBack) {
                  hasAnimatedBack = true;
                  gsap.to(withoutCenterCollectionItem, {
                    x: (i) => fullCordinateArray[i],
                    duration: 0.5,
                    ease: 'power1.outIn',
                  });
                }
                if (self.direction === 1 && progressTimeline >= 85) {
                  hasAnimatedBack = false;
                }
              }
            }
          },
        },
      });
      if (getAnimationType == 'color-based') {
        timelineRichText
          .to(richTextAnimatedColor, {
            scale: richTextCollectionItem.length > 0 ? 1 : 0,
            onComplete: () => {
              if (richTextCollectionItem.length > 0) {
                gsap.to(withoutCenterCollectionItem, {
                  x: 0,
                  duration: 0.5,
                  ease: 'power1.inOut',
                });
              }
            },
          })
          .fromTo(
            richTextObj,
            {
              '--text-reveal-percentage': '100%',
            },
            {
              '--text-reveal-percentage': '0%',
            },
            '<',
          );
        if (richTextCollectionItem.length > 0) {
          timelineRichText.to(richTextAnimatedColor, {});
        }
      }
      this.focusTabSectionsCase(richTextObj);
    }
  }
  scrollableCollectionList(scrollListObj) {
    const animationStyle = scrollListObj.getAttribute('data-animation-style');
    const getAllItem = scrollListObj.querySelectorAll('[collection-name-text]');
    const allImagesItemsList = scrollListObj.querySelectorAll('.collection-text-media');
    if (animationStyle == 'v2') {
      const allSpanTextget = scrollListObj.querySelectorAll('[collection-name-text-inner]');
      const scrollPerSlide = Math.min(window.innerHeight, 1000);
      const lengthCountElm = getAllItem.length - 1;
      gsap.set(getAllItem, { yPercent: 100 });
      gsap.set(getAllItem[0], { yPercent: 0 });
      gsap.set(allImagesItemsList, { scale: 0.7, opacity: 0 });
      gsap.set(allImagesItemsList[0], { scale: 1, opacity: 1 });
      const scrollableListColTime = gsap.timeline({
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(scrollListObj),
          trigger: scrollListObj.closest('.section-wrapper'),
          start: 'top top+=' + this.headerHeight,
          end: `+=${scrollPerSlide * lengthCountElm}`,
          scrub: 1.5,
          pin: true,
          invalidateOnRefresh: true,
          onEnter: () => {
            getAllItem[0].classList.add('active');
          },
          onLeave: () => {
            getAllItem[0].classList.remove('active');
          },
          onLeaveBack: () => {
            getAllItem[0].classList.remove('active');
          },
        },
      });
      getAllItem.forEach((itemCollect, collKey) => {
        if (collKey > 0) {
          scrollableListColTime
            .to(itemCollect, {
              yPercent: 0,
              onUpdate: function () {
                let progressTimeLine = this.progress();
                if (progressTimeLine > 0.5) {
                  itemCollect.classList.add('active');
                } else {
                  itemCollect.classList.remove('active');
                }
                if (collKey == 1 && progressTimeLine < 0.4) {
                  getAllItem[0].classList.add('active');
                }
              },
            })
            .to(allImagesItemsList[collKey], { scale: 1, opacity: 1 }, '<')
            .to(
              getAllItem[collKey - 1],
              {
                yPercent: -100,
                onComplete: () => {
                  getAllItem[collKey - 1].classList.remove('active');
                },
              },
              '<',
            )
            .to(allImagesItemsList[collKey - 1], { scale: 0.7, opacity: 0 }, '<');
        }
      });
    } else {
      gsap.set(getAllItem, { rotateX: -120 });
      const timeline = gsap.timeline({});
      let intialValue = 'top 80%';
      getAllItem.forEach((item, index) => {
        if (index > 0) {
          intialValue = 'top 50%';
        }
        timeline.to(item, {
          ease: 'power1.inOut',
          rotateX: 0,
          scrollTrigger: {
            id: `${this.scrollTriggerIdGetMayaa(scrollListObj)}_${index + 1}`,
            trigger: item,
            start: intialValue,
            end: 'bottom bottom',
            scrub: 1.5,
            invalidateOnRefresh: true,
            onUpdate: (self) => {
              if (self.progress === 0) {
                if (index > 0) {
                  for (let i = getAllItem.length - 1; i >= index - 1; i--) {
                    getAllItem[i].classList.remove('collection-inactive');
                    getAllItem[i].classList.add('active');
                  }
                }
              }
            },
            onEnter: () => {
              item.classList.add('active');
              getAllItem.forEach((otherItem) => {
                if (otherItem !== item) {
                  otherItem.classList.remove('active');
                }
              });
            },
          },
          onStart: () => {
            if (index > 0) {
              for (let i = 0; i < index; i++) {
                getAllItem[i].classList.add('collection-inactive');
              }
            }
          },
        });
        let itemImageContent = null;
        if (item.querySelector('img') != null) {
          itemImageContent = item.querySelector('img');
        } else if (item.querySelector('svg') != null) {
          itemImageContent = item.querySelector('svg');
        }
        if (itemImageContent != null) {
          itemImageContent.addEventListener('mouseenter', () => {
            item.classList.add('media-hover');
          });
          itemImageContent.addEventListener('mouseleave', () => {
            item.classList.remove('media-hover');
          });
        }
        item.addEventListener('click', function (e) {
          const getTimeLineChild = timeline.getChildren()[index];
          if (getTimeLineChild.scrollTrigger) {
            let startPointTrigger = 0;
            if (index > 0) {
              startPointTrigger = getTimeLineChild.scrollTrigger.start + 2;
            } else {
              startPointTrigger = getTimeLineChild.scrollTrigger.start + item.offsetHeight / 2;
            }
            window.scrollTo({ top: startPointTrigger, behavior: 'smooth', ease: 'power2.out' });
          }
        });
      });
    }
    this.focusTabSectionsCase(scrollListObj);
  }
  scrollingMediaCards(scrollingMediaObj) {
    if (this.getBlockSizeMayaa(scrollingMediaObj) > 1) {
      const scrollingMediaItem = scrollingMediaObj.querySelectorAll('[scrolling-media-item]');
      const headerScrollingMedia = scrollingMediaObj.querySelector('[scrolling-media-heading]');
      const scrollingMediaWrapper = scrollingMediaObj.querySelector('[scrolling-media-wrapper]');
      const scrollingMediaDescription = scrollingMediaObj.querySelector('[scrolling-media-description]');
      const imageStretchedY = scrollingMediaWrapper.offsetHeight / 4;
      gsap.set(scrollingMediaItem[1], { y: imageStretchedY });
      if (scrollingMediaItem[2]) {
        gsap.set(scrollingMediaItem[2], { y: imageStretchedY * 2 });
      }
      if (headerScrollingMedia != null) {
        gsap.set(headerScrollingMedia, { scale: 0, opacity: 0 });
      }
      if (scrollingMediaDescription != null) {
        gsap.set(scrollingMediaDescription, { scale: 0, opacity: 0 });
      }
      const scrollableMediaCards = gsap.timeline({
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(scrollingMediaObj),
          trigger: scrollingMediaObj.closest('.section-wrapper'),
          start: 'top+=10% bottom',
          end: 'bottom top',
          scrub: 1.5,
          pin: false,
          invalidateOnRefresh: true,
        },
      });
      scrollableMediaCards.to(scrollingMediaWrapper, {
        y: -imageStretchedY,
        onStart: () => {
          if (headerScrollingMedia != null) {
            gsap.to(headerScrollingMedia, { scale: 1, opacity: 1, duration: 1.5, ease: 'power4.out' });
          }
          if (scrollingMediaDescription != null) {
            gsap.to(scrollingMediaDescription, { scale: 1, opacity: 1, duration: 1.5, ease: 'power4.out' });
          }
        },
        onReverseComplete: () => {
          if (headerScrollingMedia != null) {
            gsap.set(headerScrollingMedia, { scale: 0, opacity: 0 });
          }
          if (scrollingMediaDescription != null) {
            gsap.set(scrollingMediaDescription, { scale: 0, opacity: 0 });
          }
        },
      });
      scrollableMediaCards.to(scrollingMediaItem[0], { y: imageStretchedY }, '<');
      scrollableMediaCards.to(scrollingMediaItem[1], { y: 0 }, '<');
      if (scrollingMediaItem[2]) {
        scrollableMediaCards.to(scrollingMediaItem[2], { y: -imageStretchedY }, '<');
      }
    }
  }
  mediaWithCards(mediaCardsObj) {
    const sectionIsAtFirstMedia = this.firstSectionTransparentCase(
      mediaCardsObj.getAttribute('data-section-index'),
      mediaCardsObj.getAttribute('data-section'),
    );
    const videoImageMediaWrap = mediaCardsObj.querySelector('[media-wrap-video]');
    const videoContentMediaWrap = mediaCardsObj.querySelector('[media-wrap-video-content]');
    const miniCardMediaWrap = mediaCardsObj.querySelector('[minicard-media-wrap]');
    const cotentSpacingVideoSec = gsap.getProperty(videoContentMediaWrap, '--media-content-spacing') / 2;
    const topSpacingvalue = gsap.getProperty(videoContentMediaWrap, '--media-clip-spacing-top');
    const bottomSpacingvalue = gsap.getProperty(videoContentMediaWrap, '--media-clip-spacing-bottom');
    gsap.set(videoImageMediaWrap, {
      '--media-clip-spacing-top': `${topSpacingvalue}px`,
      '--media-clip-spacing-bottom': `${bottomSpacingvalue}px`,
    });
    if (miniCardMediaWrap != null) {
      gsap.set(miniCardMediaWrap, { y: this.viewportHeight });
    }
    const mediaWithCardsTimeline = gsap.timeline({
      scrollTrigger: {
        id: this.scrollTriggerIdGetMayaa(mediaCardsObj),
        trigger: mediaCardsObj.closest('.section-wrapper'),
        start: 'top top+=' + (sectionIsAtFirstMedia ? 0 : this.headerHeight),
        end: `+=100%`,
        scrub: 1.5,
        pin: true,
        invalidateOnRefresh: true,
      },
    });
    mediaWithCardsTimeline
      .to(videoImageMediaWrap, {
        '--media-clip-spacing': '0px',
        '--card-radius': '0px',
        '--media-clip-spacing-top': '0px',
        '--media-clip-spacing-bottom': '0px',
      })
      .to(videoContentMediaWrap, { '--media-content-spacing': `${cotentSpacingVideoSec}px` }, '<');
    if (miniCardMediaWrap != null) {
      mediaWithCardsTimeline.to(miniCardMediaWrap, { y: 0 }, '<50%');
    }
    this.focusTabSectionsCase(mediaCardsObj);
  }
  imageWithTextCarousel(imageWithTextCarouselObj) {
    if (this.getBlockSizeMayaa(imageWithTextCarouselObj) > 1) {
      const sectionIsAtFirstImageWithT = this.firstSectionTransparentCase(
        imageWithTextCarouselObj.getAttribute('data-section-index'),
        imageWithTextCarouselObj.getAttribute('data-section'),
      );
      const multimediaItems = imageWithTextCarouselObj.querySelectorAll('[multi-media-item]');
      const multimediaContent = imageWithTextCarouselObj.querySelectorAll('[multi-media-item-content]');
      const multimediaItemImages = imageWithTextCarouselObj.querySelectorAll('[multi-media-item-image]');
      const paginationItemsMedia = imageWithTextCarouselObj.querySelectorAll('[multi-media-pagination]');
      const itemLengthCount = multimediaContent.length - 1;
      const scrollPerMediaSlide = Math.min(window.innerHeight, 1000);
      const xPercentValue = 4 * (multimediaContent.length - 1);
      const yPercentValue = 4 * (multimediaContent.length - 1);
      const perItemXPercent = xPercentValue / (multimediaContent.length - 1);
      const perItemYPercent = yPercentValue / (multimediaContent.length - 1);
      gsap.set(multimediaItems, { opacity: 0, yPercent: 100 });
      gsap.set(paginationItemsMedia, { opacity: 0.2 });
      gsap.set(paginationItemsMedia[0], { opacity: 1 });
      gsap.set(multimediaItemImages, { xPercent: xPercentValue });
      gsap.set(multimediaItems[0], { yPercent: 0 });
      const firstTriggerTimeline = gsap.timeline({
        scrollTrigger: {
          id: `${this.scrollTriggerIdGetMayaa(imageWithTextCarouselObj)}_0`,
          trigger: multimediaItems[0],
          start: 'top 100%',
          end: 'bottom+=20% bottom',
          scrub: 1.5,
          invalidateOnRefresh: true,
        },
      });
      firstTriggerTimeline
        .to(multimediaItems[0], { opacity: 1 })
        .to(multimediaItemImages[0], { xPercent: 0 }, '<')
        .to(paginationItemsMedia[0], { opacity: 1 }, '<');
      const multimediatimeline = gsap.timeline({
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(imageWithTextCarouselObj),
          trigger: imageWithTextCarouselObj.closest('.section-wrapper'),
          start: 'top top+=' + (sectionIsAtFirstImageWithT ? 0 : this.headerHeight),
          end: `${100 * itemLengthCount}%`,
          scrub: 1.5,
          pin: true,
          invalidateOnRefresh: true,
        },
      });
      multimediaItems.forEach((multimediaItem, mkey) => {
        if (mkey > 0) {
          multimediatimeline
            .to(multimediaItem, { yPercent: 0, opacity: 1 })
            .to(multimediaContent[mkey - 1], { opacity: 0, yPercent: -100 }, '<')
            .to(multimediaItemImages[mkey], { xPercent: perItemXPercent * mkey, yPercent: perItemYPercent * mkey }, '<')
            .to(
              multimediaItemImages[mkey - 1],
              { xPercent: mkey - 1 == 0 ? 0 : perItemXPercent, yPercent: mkey - 1 == 0 ? 0 : perItemYPercent },
              '<',
            )
            .to(paginationItemsMedia[mkey], { opacity: 1 }, '<')
            .to(paginationItemsMedia[mkey - 1], { opacity: 0.2 }, '<')
            .to(paginationItemsMedia[0], { opacity: 0.2 }, '<');
        }
      });
      this.focusTabSectionsCase(imageWithTextCarouselObj);
    }
  }
  trendingProduct(trendingProdObj) {
    const animationType = trendingProdObj.getAttribute('data-animation-type');
    const itemCardsSection = trendingProdObj.querySelectorAll('[card-item-main]');
    const itemCardCenter = trendingProdObj.querySelector('[card-item-center-area]');
    const itemCardHeader = trendingProdObj.querySelector('[card-item-header]');
    const itemCardHeaderContent = trendingProdObj.querySelector('[card-item-header-content]');
    const itemTitleFront = trendingProdObj.querySelector('[card-title-front]');
    const itemTitleBack = trendingProdObj.querySelector('[card-title-back]');
    let startPoint,
      endPoint = 0;
    const cardWidthGet = itemCardsSection[0].offsetWidth;
    const halfWindowWidthSize = window.innerWidth / 2;
    const widthCenterAreaCard = itemCardCenter.offsetWidth;
    const halfWidthcalculated = widthCenterAreaCard / 2;
    gsap.set(itemCardsSection, { opacity: 0, scale: 0.5, rotationY: 70 });
    if (animationType != 'style-2') {
      gsap.set([itemTitleFront, itemTitleBack], { x: (i) => (i == 0 ? -2 : 2) });
    }
    itemCardsSection.forEach((itemCard, indexI) => {
      const zVal = 10 * indexI;
      const boundryReactData = itemCard.getBoundingClientRect();
      const xCreated = halfWidthcalculated - boundryReactData.x + boundryReactData.width;
      gsap.set(itemCard, { x: xCreated, z: `${zVal}px` });
    });
    gsap.set(itemCardsSection, { transformStyle: 'preserve-3d', perspective: 1000 });
    gsap.set(itemCardCenter, { transformStyle: 'preserve-3d', perspective: 1000 });
    if (animationType == 'style-2') {
      startPoint = 0.8;
      endPoint = 10;
      gsap.set(itemCardHeader, { y: cardWidthGet / 2 });
    } else {
      startPoint = 0.55;
      endPoint = 35;
      const innerTextHeader = itemCardHeaderContent.textContent || itemCardHeaderContent.innerText;
      const lengthTextHeader = Math.ceil(innerTextHeader.length / 2);
      const equalPartsContent = divideHeaderStringIntoEqualParts(innerTextHeader, lengthTextHeader);
      itemTitleFront.innerText = equalPartsContent[0];
      itemTitleBack.innerText = equalPartsContent[1];
    }
    const scrollingCardsTimeline = gsap.timeline({
      scrollTrigger: {
        id: this.scrollTriggerIdGetMayaa(trendingProdObj),
        trigger: trendingProdObj.closest('.section-wrapper'),
        start: () => `top top+=${window.innerHeight * startPoint}`,
        end: `bottom bottom-=${endPoint}%`,
        scrub: 1.5,
        invalidateOnRefresh: true,
      },
    });
    if (animationType == 'style-2') {
      scrollingCardsTimeline.to(itemCardHeader, { y: 0 });
    } else {
      scrollingCardsTimeline.to([itemTitleFront, itemTitleBack], {
        x: (i) => (i == 0 ? -halfWindowWidthSize : halfWindowWidthSize),
        opacity: 0,
      });
    }
    scrollingCardsTimeline.to(itemCardsSection, { x: 0, rotationY: 0, scale: 1, opacity: 1, z: 0 }, '<');
    function divideHeaderStringIntoEqualParts(string, halfLength) {
      let resultParts = [];
      for (let i = 0; i < string.length; i += halfLength) {
        resultParts.push(string.slice(i, i + halfLength));
      }
      return resultParts;
    }
    this.focusTabSectionsCase(trendingProdObj);
  }
  mainProductSpecification(productSpecificationObj) {
    const sectionIsAtFirstProductSpecific = this.firstSectionTransparentCase(
      productSpecificationObj.getAttribute('data-section-index'),
      productSpecificationObj.getAttribute('data-section'),
    );
    const productHighlightSection = productSpecificationObj.querySelectorAll('[product-highlight-section]');
    const highlightProductTimeline = gsap.timeline({
      scrollTrigger: {
        id: this.scrollTriggerIdGetMayaa(productSpecificationObj),
        trigger: productSpecificationObj.closest('.section-wrapper'),
        start: 'top top+=' + (sectionIsAtFirstProductSpecific ? 0 : this.headerHeight),
        end: `+=${75 * productHighlightSection.length}%`,
        scrub: 1.5,
        pin: true,
        invalidateOnRefresh: true,
      },
    });
    productHighlightSection.forEach((highlightItem, indexItem) => {
      const highlightLeftBox = highlightItem.querySelector('[highlight-left-box]');
      const highlightRightBox = highlightItem.querySelector('[highlight-right-box]');
      const hightlightCenterBox = highlightItem.querySelector('[highlight-center-box]');
      const hightlightLeftBar = highlightItem.querySelector('[highlight-left-bar]');
      const hightlightRightBar = highlightItem.querySelector('[highlight-right-bar]');
      const widthCenterHighlight = hightlightCenterBox.getBoundingClientRect().width;
      gsap.set(productHighlightSection, { '--pointer-line-size': `${widthCenterHighlight}px` });
      gsap.set(hightlightLeftBar, { '--media-line-width': '0%' });
      gsap.set(hightlightRightBar, { '--info-line-width': '0%' });
      gsap.set([highlightLeftBox, highlightRightBox], { opacity: 0 });
      gsap.set(highlightLeftBox, { scale: 0 });
      highlightProductTimeline
        .to(hightlightRightBar, { '--info-line-width': '100%' })
        .to(hightlightLeftBar, { '--media-line-width': '100%' }, '<')
        .to(
          highlightLeftBox,
          {
            x: 0,
            scale: 1,
            opacity: 1,
            onComplete: () => {
              if (indexItem < productHighlightSection.length - 1) {
                productHighlightSection[indexItem].classList.remove('active');
                productHighlightSection[indexItem].classList.add('in-active');
                productHighlightSection[indexItem + 1].classList.remove('in-active');
                productHighlightSection[indexItem + 1].classList.add('active');
              }
            },
            onReverseComplete: () => {
              if (indexItem > 0) {
                productHighlightSection[indexItem].classList.remove('active');
                productHighlightSection[indexItem].classList.add('in-active');
                productHighlightSection[indexItem - 1].classList.remove('in-active');
                productHighlightSection[indexItem - 1].classList.add('active');
              }
            },
          },
          '<',
        )
        .to(highlightRightBox, { opacity: 1 }, '<+=35%');
    });
  }
  highlightTextWithImage(highlightTextObj) {
    let matchMediaCheckHighLight = gsap.matchMedia();
    const textContentArea = highlightTextObj.querySelector('[highlight-text-content]');
    const widthMediaImage = gsap.getProperty(textContentArea, '--sentence-media-width');
    const splitLineWords = new SplitText(textContentArea, { type: 'words', wordsClass: 'media-sentence-words' });
    matchMediaCheckHighLight.add('(max-width: 767px)', () => {
      if (splitLineWords) {
        splitLineWords.revert();
      }
    });
    const mediaSetenceWords = highlightTextObj.querySelectorAll('.media-sentence-words');
    const offsetWidthSec = textContentArea.getBoundingClientRect().width;
    const extraSpaceNeededEachWord = 55;
    let currentLine = document.createElement('div');
    currentLine.classList.add('media-sentence-lines');
    textContentArea.appendChild(currentLine);
    let widthEachWord = 0;
    mediaSetenceWords.forEach((wordItem, indexWord) => {
      let classCreated = 'text-based';
      let wordItemHtml = wordItem.innerHTML;
      let imageSection = false;
      if (wordItem.classList.contains('sentence-media')) {
        classCreated = 'sentence-media';
        imageSection = true;
      } else {
        wordItemHtml = wordItemHtml.trim();
      }
      let eachWordOffSet = wordItem.offsetWidth;
      if (eachWordOffSet == 0) {
        eachWordOffSet = widthMediaImage;
      } else {
        eachWordOffSet = wordItem.offsetWidth + extraSpaceNeededEachWord;
      }
      widthEachWord = widthEachWord + eachWordOffSet;
      if (widthEachWord > offsetWidthSec) {
        widthEachWord = 0 + eachWordOffSet;
        currentLine = document.createElement('div');
        currentLine.classList.add('media-sentence-lines');
        textContentArea.appendChild(currentLine);
      }
      const wordSpan = document.createElement('span');
      wordSpan.classList.add(classCreated);
      if (imageSection) {
        wordSpan.classList.add('media-wrapper');
      }
      wordSpan.innerHTML = wordItemHtml;
      currentLine.appendChild(wordSpan);
    });
    mediaSetenceWords.forEach((elementItem) => elementItem.remove());
    const getAllLinesData = highlightTextObj.querySelectorAll('.media-sentence-lines');
    const highlightTextTimeline = gsap.timeline({});
    let intialValueTextHighlight = 'top 85%';
    getAllLinesData.forEach((linesItem, indexK) => {
      linesItem.setAttribute('data-line-count', indexK + 1);
      if (indexK > 0) {
        intialValueTextHighlight = 'top 60%';
      }
      highlightTextTimeline.to(linesItem, {
        scrollTrigger: {
          id: `${this.scrollTriggerIdGetMayaa(highlightTextObj)}_${indexK + 1}`,
          trigger: linesItem,
          start: intialValueTextHighlight,
          end: 'bottom bottom',
          scrub: 1.5,
          invalidateOnRefresh: true,
          onEnter: () => {
            linesItem.classList.add('active');
          },
          onLeaveBack: () => {
            linesItem.classList.remove('active');
          },
        },
      });
    });
    this.focusTabSectionsCase(highlightTextObj);
  }
  mixAndMatchBundle(mixMatchObj) {
    const animationStyleData = this.getSectionAnimationStyle(mixMatchObj);
    if (animationStyleData == 'none') {
      return false;
    }
    const sectionIsAtFirstMixMatch = this.firstSectionTransparentCase(
      mixMatchObj.getAttribute('data-section-index'),
      mixMatchObj.getAttribute('data-section'),
    );
    const verticalContainer = mixMatchObj.querySelector('[bundle-product-wrapper-masonry]');
    const leftSection = verticalContainer.querySelectorAll('.even-masonry');
    const rightSection = verticalContainer.querySelectorAll('.odd-masonry');
    const wraperHeight = mixMatchObj.querySelector('[bundle-product-wrapper]');
    const getAllBundleItem = mixMatchObj.querySelectorAll('[bundle-product-item]');
    const timelineMasonry = gsap.timeline({
      scrollTrigger: {
        id: this.scrollTriggerIdGetMayaa(mixMatchObj),
        trigger: mixMatchObj,
        start: 'top top+=' + (sectionIsAtFirstMixMatch ? 0 : this.headerHeight),
        end: `+=150%`,
        scrub: 1.5,
        toggleActions: 'play none none reverse',
        invalidateOnRefresh: true,
      },
    });
    const newHeightWrapper = verticalContainer.clientHeight - getAllBundleItem[0].clientHeight / 2;
    gsap.set(wraperHeight, { height: newHeightWrapper });
    timelineMasonry
      .to(leftSection, { yPercent: -10, y: -`${getAllBundleItem[0].clientHeight / 2}`, duration: 1.2, ease: 'none' })
      .to(
        rightSection,
        { yPercent: -10, y: -`${getAllBundleItem[0].clientHeight / 2}`, duration: 2, ease: 'none' },
        '<',
      );
    this.focusTabSectionsCase(mixMatchObj);
  }
  featuredCollectionsList(featureListObje) {
    if (this.getBlockSizeMayaa(featureListObje) > 0) {
      const sectionIsAtFirstCollList = this.firstSectionTransparentCase(
        featureListObje.getAttribute('data-section-index'),
        featureListObje.getAttribute('data-section'),
      );
      let matchMediaCheckFeature = gsap.matchMedia();
      const imageCollectionList = featureListObje.querySelector('[feature-collection-list-img]');
      const imageCollectionListMainMedia = featureListObje.querySelectorAll('[feature-collection-list-main-media]');
      const featureColllectionLeftWraper = featureListObje.querySelector('[feature-collection-list-wrapper]');
      const featureCollectionListLeftHeading = featureListObje.querySelectorAll(
        '[feature-collection-list-left-heading]',
      );
      const featureCollectionImgDesc = featureListObje.querySelectorAll('[feature-collection-list-img-desc]');
      const featureCollectionImgDecInner = featureListObje.querySelectorAll('[feature-collection-list-img-desc-inner]');

      const featureCollectionListMultiMedia = featureListObje.querySelectorAll(
        '[feature-collection-list-multi-media-img]',
      );
      const featureCollectionListMainWrapper = featureListObje.querySelector('[featured-collections-main-wrapper]');
      const featureCollectionListChildTab = featureListObje.querySelectorAll('[feature-collection-tab-child]');
      const featureCollectionListContentSec = featureListObje.querySelectorAll('[feature-list-tabs-content-sec]');
      const textDescInnerImg = featureListObje.querySelectorAll('[feature-collection-text-inner-img]');
      const textEmptySection = featureListObje.querySelectorAll('[feature-collection-list-empty-sec]');
      const featureCollectionFront = featureListObje.querySelector('[feature-collection-list-front]');
      const collectionListTabs = featureListObje.querySelector('[feature-collection-list-tab]');
      const childrenOfTabs = Array.from(collectionListTabs.children);
      const offsetHeightListTab = collectionListTabs.offsetHeight;
      gsap.set(featureCollectionListMainWrapper, { '--list-tabs-height': `${offsetHeightListTab}px` });
      let spacingBetween = 0;
      let textCollectionHeadingSplit,
        textCollectionHeadingWord,
        textParentDescImg,
        textChildDescImg = '';
      activeClassRemovedContentTab(
        featureCollectionListChildTab,
        featureCollectionListContentSec,
        featureCollectionListLeftHeading,
      );

      if (featureCollectionImgDesc.length > 0) {
        const getHeightValueDesc = gsap.getProperty(featureCollectionImgDesc[0], '--text-box-height');
        const percentageWidthData = (getHeightValueDesc / featureCollectionImgDesc[0].offsetWidth) * 100;
        gsap.set(featureCollectionImgDesc, { opacity: 0 });
        gsap.set(featureCollectionImgDecInner, { width: `${percentageWidthData}%` });
      }

      let centeredCollectionLoad = Math.floor(featureCollectionListChildTab.length / 2);
      centeredCollectionLoad = centeredCollectionLoad;
      const getActiveCollectionHead = featureCollectionListLeftHeading[centeredCollectionLoad].querySelector(
        '[feature-collection-heading-common]',
      );
      if (textDescInnerImg.length > 0) {
        textParentDescImg = new SplitText(textDescInnerImg, { type: 'words,chars', charsClass: 'featureDescParent' });
        textChildDescImg = new SplitText(textDescInnerImg, { type: 'chars' });
        gsap.set(textDescInnerImg, { opacity: 0 });
      }

      textCollectionHeadingWord = new SplitText(getActiveCollectionHead, {
        type: 'words',
        wordsClass: 'featureWordParent',
      });
      textCollectionHeadingSplit = new SplitText(getActiveCollectionHead, { type: 'chars' });
      matchMediaCheckFeature.add('(max-width: 767px)', () => {
        if (textCollectionHeadingSplit) {
          textCollectionHeadingSplit.revert();
        }
        if (textCollectionHeadingWord) {
          textCollectionHeadingWord.revert();
        }
        if (textParentDescImg) {
          textParentDescImg.revert();
        }
        if (textChildDescImg) {
          textChildDescImg.revert();
        }
      });
      featureCollectionListChildTab[centeredCollectionLoad].classList.add('active-tab');
      featureCollectionListContentSec[centeredCollectionLoad].classList.add('active');
      featureCollectionListLeftHeading[centeredCollectionLoad].classList.add('fade-in');
      const colrSchemeDataLoad = getCurrentSchemeFeature(featureListObje.closest('.section-wrapper'));
      const currenColorSchemeLoad =
        featureCollectionListChildTab[centeredCollectionLoad].getAttribute('data-color-scheme');
      featureListObje.closest('.section-wrapper').classList.replace(colrSchemeDataLoad, currenColorSchemeLoad);
      gsap.set(textEmptySection, { scaleX: 0 });

      gsap.set(featureColllectionLeftWraper, { opacity: 0 });

      gsap.set(featureCollectionListMultiMedia, { scale: 0 });
      gsap.set(imageCollectionList, { xPercent: -100, scale: 0.7 });

      featureCollectionListChildTab.forEach((tabItem, tabIndex) => {
        tabItem.addEventListener('click', function () {
          if (!this.classList.contains('active-tab')) {
            activeClassRemovedContentTab(
              featureCollectionListChildTab,
              featureCollectionListContentSec,
              featureCollectionListLeftHeading,
            );
            const colrSchemeData = getCurrentSchemeFeature(featureListObje.closest('.section-wrapper'));
            const currenColorScheme = this.getAttribute('data-color-scheme');
            featureListObje.closest('.section-wrapper').classList.replace(colrSchemeData, currenColorScheme);
            featureCollectionListContentSec[tabIndex].classList.add('active');
            featureCollectionListLeftHeading[tabIndex].classList.add('fade-in');
            let timelineChildGetFirstChildC = featureCollectionListTimeLine.getChildren()[0];
            if (timelineChildGetFirstChildC.progress() === 1) {
              gsap.set(featureColllectionLeftWraper, { opacity: 1 });
              if (textCollectionHeadingSplit) {
                textCollectionHeadingSplit.revert();
              }
              if (textCollectionHeadingWord) {
                textCollectionHeadingWord.revert();
              }
              let getDataNeWText = featureCollectionListLeftHeading[tabIndex].querySelector(
                '[feature-collection-heading-common]',
              );
              textCollectionHeadingWord = new SplitText(getDataNeWText, {
                type: 'words',
                wordsClass: 'featureWordParent',
              });

              textCollectionHeadingSplit = new SplitText(getDataNeWText, { type: 'chars' });
              if (textChildDescImg) {
                if (textParentDescImg) {
                  textParentDescImg.revert();
                }
                if (textChildDescImg) {
                  textChildDescImg.revert();
                }
                gsap.from(textChildDescImg.chars, {
                  opacity: 0,
                  ease: 'circ.out',
                  stagger: 0.005,
                });
              }
              gsap.from(textCollectionHeadingSplit.chars, {
                duration: 0.8,
                opacity: 0,
                stagger: 0.02,
                rotationX: 90,
                ease: 'expo.out',
              });
            }
            while (childrenOfTabs.indexOf(tabItem) !== Math.floor(featureCollectionListChildTab.length / 2)) {
              childrenOfTabs.push(childrenOfTabs.shift());
            }
            childrenOfTabs.forEach((i) => collectionListTabs.appendChild(i));
            updateButtonItemPositions();
          }
        });
      });
      const featureCollectionListTimeLine = gsap.timeline({
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(featureListObje),
          trigger: featureListObje,
          start: 'top top+=' + (sectionIsAtFirstCollList ? 0 : this.headerHeight),
          end: `+=150%`,
          scrub: true,
          pin: true,
          invalidateOnRefresh: true,
          onUpdate: (self) => {
            const timelineChildGetFirstChild = featureCollectionListTimeLine.getChildren()[0];
            const timelineChildGetSecondChild = featureCollectionListTimeLine.getChildren()[1];
            const timelineChildGetThirdChild = featureCollectionListTimeLine.getChildren()[2];
            const timelineChildGetFourthChild = featureCollectionListTimeLine.getChildren()[3];
            const firstTweenProgress = timelineChildGetFirstChild.progress();
            const secondTweenProgress = timelineChildGetSecondChild.progress();
            const thirdTweenProgress = timelineChildGetThirdChild.progress();
            const fourthTweenProgress = timelineChildGetFourthChild.progress();
            if (self.direction === 1) {
              if (firstTweenProgress > 0) {
                collectionListTabs.classList.add('tabs-pos-top');
                featureCollectionListMainWrapper.classList.add('tab-content-active');
                if (featureCollectionFront && featureCollectionFront != null) {
                  featureCollectionFront.classList.add('fade-out-text');
                }
              }
              if (secondTweenProgress > 0.2) {
                if (featureCollectionImgDesc.length > 0) {
                  gsap.set(featureCollectionImgDecInner, { opacity: 1 });
                }
              }
              if (featureCollectionImgDesc.length > 0) {
                if (fourthTweenProgress > 0) {
                  gsap.to(imageCollectionListMainMedia, { scale: 0, duration: 0.15, ease: 'sine.outIn' });
                  gsap.to(featureCollectionListMultiMedia, { scale: 1, duration: 0.18, ease: 'sine.inOut' });
                }
              } else {
                if (thirdTweenProgress > 0.5) {
                  gsap.to(imageCollectionListMainMedia, { scale: 0, duration: 0.15, ease: 'sine.outIn' });
                  gsap.to(featureCollectionListMultiMedia, { scale: 1, duration: 0.18, ease: 'sine.inOut' });
                }
              }
            } else {
              if (firstTweenProgress < 0.1) {
                collectionListTabs.classList.remove('tabs-pos-top');
                gsap.to(collectionListTabs, {
                  ease: 'Power2.easeIn',
                  onComplete: () => {
                    featureCollectionListMainWrapper.classList.remove('tab-content-active');
                    if (featureCollectionFront && featureCollectionFront != null) {
                      featureCollectionFront.classList.remove('fade-out-text');
                    }
                  },
                });
              }
              if (secondTweenProgress < 0.9) {
                gsap.set(textDescInnerImg, { opacity: 0 });
              }
              if (secondTweenProgress < 0.2) {
                if (featureCollectionImgDesc.length > 0) {
                  gsap.set(featureCollectionImgDecInner, { opacity: 0 });
                }
                gsap.set(featureColllectionLeftWraper, { opacity: 0 });
              }
              if (thirdTweenProgress < 0.9) {
                gsap.to(imageCollectionListMainMedia, { scale: 1, duration: 0.15, ease: 'sine.outIn' });
                gsap.to(featureCollectionListMultiMedia, { scale: 0, duration: 0.18, ease: 'sine.inOut' });
              }
            }
          },
        },
      });
      featureCollectionListTimeLine.to(imageCollectionList, {
        xPercent: 0,
        scale: 1,
        onStart: () => {
          collectionListTabs.classList.add('tabs-pos-top');
          featureCollectionListMainWrapper.classList.add('tab-content-active');
          if (featureCollectionFront && featureCollectionFront != null) {
            featureCollectionFront.classList.add('fade-out-text');
          }
        },
        onComplete: () => {
          if (featureCollectionImgDesc.length > 0) {
            gsap.set(featureCollectionImgDesc, { opacity: 1 });
          }
          gsap.set(featureColllectionLeftWraper, { opacity: 1 });
          gsap.from(textCollectionHeadingSplit.chars, {
            duration: 0.8,
            opacity: 0,
            stagger: 0.02,
            rotationX: 90,
            ease: 'expo.out',
          });
        },
      });
      if (featureCollectionImgDesc.length > 0) {
        featureCollectionListTimeLine
          .to(featureCollectionImgDecInner, {
            width: `100%`,
            onComplete: () => {
              gsap.set(textDescInnerImg, { opacity: 1 });
              gsap.from(textChildDescImg.chars, {
                opacity: 0,
                ease: 'circ.out',
                stagger: 0.004,
              });
            },
          })
          .to(textEmptySection, {
            scaleX: 1,
          })
          .to(textEmptySection, {
            scaleX: 0,
          });
      } else {
        featureCollectionListTimeLine
          .to(textEmptySection, {
            scaleX: 1,
            onComplete: () => {
              gsap.set(textDescInnerImg, { opacity: 1 });
              gsap.from(textChildDescImg.chars, {
                opacity: 0,
                ease: 'circ.out',
                stagger: 0.004,
              });
            },
          })
          .to(textEmptySection, {
            scaleX: 0,
          });
      }
      featureCollectionListTimeLine.add(() => {}, '+=0.10');
      function activeClassRemovedContentTab(elementTab, contentElements, rightContentElement) {
        elementTab.forEach((tItem, indexD) => {
          tItem.classList.remove('active-tab');
          contentElements[indexD].classList.remove('active');
          rightContentElement[indexD].classList.remove('fade-in');
        });
      }
      function updateButtonItemPositions() {
        const allButtons = featureListObje.querySelectorAll('[feature-collection-tab-child]');
        const centerIndexButton = Math.floor(featureCollectionListChildTab.length / 2);
        featureCollectionListChildTab.forEach((itemButton, index) => {
          const offsetTranslate = index - centerIndexButton;
          let zIndex = 10 - Math.abs(offsetTranslate);
          gsap.set(itemButton, { zIndex: zIndex });
          gsap.to(itemButton, {
            x: offsetTranslate * spacingBetween,
            duration: 0.3,
            ease: 'power2.out',
            onCompleteAll: () => {
              allButtons[centerIndexButton].classList.add('active-tab');
            },
          });
        });
      }
      function getCurrentSchemeFeature(targetDiv) {
        const classes = Array.from(targetDiv.classList);
        return classes.find((cls) => cls.startsWith('scheme-')) || null;
      }
      this.focusTabSectionsCase(featureListObje);
    }
  }
  scrollSlidesBanner(scrollSlideObj) {
    if (this.getBlockSizeMayaa(scrollSlideObj) > 1) {
      const sectionIsAtFirstScrollSlide = this.firstSectionTransparentCase(
        scrollSlideObj.getAttribute('data-section-index'),
        scrollSlideObj.getAttribute('data-section'),
      );
      const getAllSlidesItem = scrollSlideObj.querySelectorAll('[scroll-slide-item]');
      const progressBarScrollSlide = scrollSlideObj.querySelectorAll('[scroll-slide-progress]');
      const progressBarScrollSlideBar = scrollSlideObj.querySelectorAll('[scroll-slide-progress-bar]');
      const slideScrollId = this.scrollTriggerIdGetMayaa(scrollSlideObj);
      const triggerLengthHalf = getAllSlidesItem.length - 1;
      const scrollPerBannerSlide = Math.min(window.innerHeight, 1000);
      gsap.set(getAllSlidesItem, { yPercent: 100 });
      gsap.set(getAllSlidesItem[0], { yPercent: 0 });
      getAllSlidesItem[0].classList.add('is-current');
      const scrollSlidesTimeLine = gsap.timeline({
        scrollTrigger: {
          id: this.scrollTriggerIdGetMayaa(scrollSlideObj),
          trigger: scrollSlideObj,
          start: 'top top+=' + (sectionIsAtFirstScrollSlide ? 0 : this.headerHeight),
          end: `+=${scrollPerBannerSlide * triggerLengthHalf}`,
          scrub: true,
          pin: true,
          toggleActions: 'play none reverse none',
          invalidateOnRefresh: true,
          onEnter: () => {
            scrollSlideObj.classList.add('section-banner-pinned');
          },
          onLeaveBack: () => {
            scrollSlideObj.classList.remove('section-banner-pinned');
          },
        },
      });

      getAllSlidesItem.forEach((panelItem, i) => {
        const cricleProgress = progressBarScrollSlide[i].querySelector(
          '[scroll-slide-circle], [scroll-slide-progress-bar]',
        );
        scrollSlidesTimeLine.fromTo(
          cricleProgress,
          {
            '--scroll-slide-circle-progress': 1,
            '--scroll-slide-bar-progress': '0%',
          },
          {
            '--scroll-slide-circle-progress': 0,
            '--scroll-slide-bar-progress': '100%',
            ease: 'power2.out',
            onStart: () => {
              if (i == 0) {
                progressBarScrollSlide[i].classList.add('active');
                getAllSlidesItem[i].classList.add('is-current');
              }
            },
            onComplete: () => {
              if (getAllSlidesItem[i + 1]) {
                gsap.to(getAllSlidesItem[i + 1], { yPercent: 0 });
                removeActiveClass(i + 1);
              }
            },
            onReverseComplete: () => {
              if (i > 0) {
                gsap.to(getAllSlidesItem[i], { yPercent: 100 });
              }
              removeActiveReversClass(i);
            },
          },
        );
        progressBarScrollSlide[i].addEventListener('click', (ev) => {
          removeActiveClass(i);
          const scrollTriggerDataGet = ScrollTrigger.getById(slideScrollId);
          const totalScrollSlide = scrollTriggerDataGet.end - scrollTriggerDataGet.start;
          const slideHeightEach = totalScrollSlide / triggerLengthHalf;
          let scrollToPositionSlideBanner = scrollTriggerDataGet.start + slideHeightEach * i + 100;
          if (i == 0) {
            scrollToPositionSlideBanner = scrollTriggerDataGet.start;
          }
          if (i == triggerLengthHalf) {
            scrollToPositionSlideBanner = scrollTriggerDataGet.end;
          }
          gsap.to(window, { scrollTo: scrollToPositionSlideBanner, duration: 0.5, ease: 'power2.inOut' });
        });
      });
      function removeActiveClass(j) {
        for (let i = 0; i < progressBarScrollSlide.length - 1; i++) {
          progressBarScrollSlide[i].classList.remove('active');
          getAllSlidesItem[i].classList.remove('is-current');
        }
        progressBarScrollSlide[j].classList.add('active');
        getAllSlidesItem[j].classList.add('is-current');
        if (j == 0) {
          progressBarScrollSlide[j].classList.add('active');
          getAllSlidesItem[j].classList.add('is-current');
        }
      }
      function removeActiveReversClass(j) {
        if (progressBarScrollSlide[j].classList.contains('active')) {
          progressBarScrollSlide[j].classList.remove('active');
          getAllSlidesItem[j].classList.remove('is-current');
          if (j > 0) {
            progressBarScrollSlide[j - 1].classList.add('active');
            getAllSlidesItem[j - 1].classList.add('is-current');
          }
          if (j == 0) {
            progressBarScrollSlide[j].classList.add('active');
            getAllSlidesItem[j].classList.add('is-current');
          }
        }
      }
      this.focusTabSectionsCase(scrollSlideObj);
    }
  }

  wavyMarquee(wavyMarqueeObj) {
    const textPath = wavyMarqueeObj.querySelector('[data-wavy-text-path]');
    if (!textPath) return;

    const rotationStyle = wavyMarqueeObj.getAttribute('data-rotation-style');
    const marqueeDirection = wavyMarqueeObj.getAttribute('data-marquee-direction');
    const scrollingSpeed = parseFloat(wavyMarqueeObj.dataset.scrollingSpeed) || 20;

    const fromOffset = marqueeDirection === 'rtl' ? '0%' : '-100%';
    const toOffset = marqueeDirection === 'rtl' ? '-100%' : '0%';

    const containerWidth = wavyMarqueeObj.getBoundingClientRect().width;
    const textPathWidth = textPath.getBoundingClientRect().width;
    const repeatCount = Math.ceil((containerWidth * 2) / textPathWidth) || 0;
    const originalText = textPath.textContent.trim();
    textPath.textContent = Array(repeatCount).fill(originalText).join('   ');

    const marqueeTween = gsap.fromTo(
      textPath,
      { attr: { startOffset: fromOffset } },
      {
        attr: { startOffset: toOffset },
        duration: scrollingSpeed,
        ease: 'none',
        repeat: -1,
        paused: rotationStyle === 'onscroll',
      },
    );
    marqueeTween.timeScale(1);
    let scrollTimeout;
    if (rotationStyle === 'onscroll' || rotationStyle === 'both') {
      ScrollTrigger.create({
        id: this.scrollTriggerIdGetMayaa(wavyMarqueeObj),
        trigger: wavyMarqueeObj,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        onUpdate(self) {
          console.log(scrollingSpeed);
          marqueeTween.timeScale(0);
          marqueeTween.progress(self.progress);
          clearTimeout(scrollTimeout);
          if (rotationStyle === 'both') {
            scrollTimeout = setTimeout(() => {
              gsap.to(marqueeTween, {
                timeScale: 1,
                duration: 0.3,
                ease: 'none',
              });
            }, scrollingSpeed);
          }
        },
      });
    }
    if (rotationStyle === 'always' || rotationStyle === 'both') {
      //marqueeTween.play();
      marqueeTween.timeScale(1).play();
    }
  }
  lenisIntializationData() {
    let matchMediaCheckIntial = gsap.matchMedia();
    matchMediaCheckIntial.add('(min-width: 768px)', () => {
      const lenis = new Lenis({
        duration: 1.5,
        easing: (t) => 1 - Math.pow(1 - t, 3),
        smooth: true,
        sync: true,
        smoothTouch: false,
        infinite: false,
        syncTouch: true,
        autoResize: true,
      });
      window.lenis = lenis;
      ScrollTrigger.defaults({
        pinType: 'transform',
        overwrite: 'auto',
        anticipatePin: 1,
        pin: false,
      });
      ScrollTrigger.config({
        autoRefreshEvents: 'DOMContentLoaded,load,resize',
        ignoreMobileResize: true,
      });
      function raf(time) {
        lenis.raf(time);
        ScrollTrigger.update();
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);
    });
  }
  lenisDestroyData() {
    if (window.lenis && typeof window.lenis.raf === 'function') {
      lenis.destroy();
    }
  }
  scrollTriggerIdGetMayaa(sectionElementsData) {
    const sectionIdScrollTrigger = sectionElementsData.getAttribute('data-section');
    return sectionIdScrollTrigger;
  }
  getBlockSizeMayaa(sectionElementObj) {
    const blockSizeSection = parseInt(sectionElementObj.getAttribute('data-block-size'));
    return blockSizeSection;
  }
  getSectionAnimationStyle(sectionElementsData) {
    const sectionAnimationStyle = sectionElementsData.getAttribute('data-animation-style');
    return sectionAnimationStyle;
  }
  getHeaderHeight() {
    return this.headerHeight;
  }
  getPixelToVw(heightPx) {
    const getVwValue = (heightPx / this.viewportWidth) * 100;
    return parseFloat(getVwValue.toFixed(2));
  }
  firstSectionTransparentCase(sectionIndex, sectionIdGet) {
    if (this.transparentHeader == 'true') {
      if (Shopify.designMode) {
        const idEditorSide = `shopify-section-${sectionIdGet}`;
        const getMainIdBody = document.getElementById('MainContent');
        const allSectionEditor = getMainIdBody.querySelectorAll('section');
        const tagertSection = document.getElementById(idEditorSide);
        const indexSectionGet = Array.from(allSectionEditor).indexOf(tagertSection);
        if (indexSectionGet == 0) {
          return true;
        } else {
          return false;
        }
      } else {
        if (sectionIndex == '1') {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }
  focusTabSectionsCase(sectionObject) {
    let countTwoRow = 0;
    let countThreeRow = 0;
    let isShiftTab = false;
    window.addEventListener('keydown', (e) => {
      isShiftTab = e.shiftKey && e.key === 'Tab';
    });
    sectionObject.addEventListener('focusin', (event) => {
      const sectionIdObject = sectionObject.getAttribute('data-section');
      const methodObject = sectionObject.getAttribute('methodcalled');
      if (this.lastFocusedSectionTab !== sectionIdObject) {
        this.lastFocusedSectionTab = sectionIdObject;
        if (
          methodObject == 'scrollableCollectionList' ||
          methodObject == 'trendingProduct' ||
          methodObject == 'mixAndMatchBundle' ||
          methodObject == 'highlightTextWithImage'
        ) {
          if (methodObject == 'scrollableCollectionList') {
            const blockSize = sectionObject.getAttribute('data-block-size');
            const focusedElement = event.target;
            const focusedParent = focusedElement.parentElement.closest('[collection-name-text]');
            const focusedBlock = focusedParent.getAttribute('sclist-block-index');
            const animationStyles = sectionObject.getAttribute('data-animation-style');
            if (animationStyles == 'v2') {
              const scrollTriggerAllValue = ScrollTrigger.getById(sectionIdObject);
              const sectionScrollPointY = scrollTriggerAllValue.end;
              const sectionScrollPointYStart = scrollTriggerAllValue.start;
              const scrollDifference = sectionScrollPointY - sectionScrollPointYStart;
              const scrollDivide = scrollDifference / (blockSize - 1);
              let scrollYPosition = sectionScrollPointYStart + scrollDivide * (focusedBlock - 1);
              if (focusedBlock == 1) {
                scrollYPosition = sectionScrollPointYStart;
              }
              gsap.to(window, { scrollTo: scrollYPosition, ease: 'none' });
            } else {
              const idCreate = `${sectionIdObject}_${focusedBlock}`;
              const scrollTriggerAllValue = ScrollTrigger.getById(idCreate);
              if (focusedBlock > 1) {
                gsap.to(window, { scrollTo: scrollTriggerAllValue.start, ease: 'none' });
              }
            }
          } else if (methodObject == 'trendingProduct') {
            const scrollTriggerAllValue = ScrollTrigger.getById(sectionIdObject);
            gsap.to(window, { scrollTo: scrollTriggerAllValue.end, ease: 'none' });
          } else if (methodObject == 'mixAndMatchBundle') {
            const scrollTriggerAllValue = ScrollTrigger.getById(sectionIdObject);
            const focusedElement = event.target;
            const focusedParent = focusedElement.parentElement.closest('[bundle-product-item]');
            if (!focusedParent.previousElementSibling) {
              gsap.to(window, { scrollTo: scrollTriggerAllValue.start, ease: 'none' });
            }
          } else if (methodObject == 'highlightTextWithImage') {
            const focusedElement = event.target;
            const focusedParent = focusedElement.parentElement.closest('[data-hightlight-item]');
            const mainParentGet = focusedParent.parentElement.closest('[data-line-count]');
            const focusedBlock = mainParentGet.getAttribute('data-line-count');
            const idCreate = `${sectionIdObject}_${focusedBlock}`;
            const scrollTriggerAllValue = ScrollTrigger.getById(idCreate);
            if (focusedBlock > 1) {
              gsap.to(window, { scrollTo: scrollTriggerAllValue.start, ease: 'none' });
            }
          }
        } else {
          const scrollTriggerAllValue = ScrollTrigger.getById(sectionIdObject);
          const sectionScrollPointY = scrollTriggerAllValue.end;
          const sectionScrollPointYStart = scrollTriggerAllValue.start;
          let yScrol = 0;
          if (methodObject == 'productsGrid') {
            const focusedElement = event.target;
            const getParentElement = focusedElement.parentElement;
            if (getParentElement.classList.contains('two-rows')) {
              countThreeRow = 0;
              countTwoRow = countTwoRow + 1;
              let topg = gsap.getProperty(getParentElement, 'top');
              let topGetParent = topg * countTwoRow;
              yScrol = sectionScrollPointY + topGetParent;
            } else if (getParentElement.classList.contains('three-rows')) {
              countTwoRow = 0;
              let topg = gsap.getProperty(getParentElement, 'marginTop') + 25;
              if (isShiftTab) {
                countThreeRow = countThreeRow + 1;
                let multiplier = 3 - countThreeRow;
                let topGetParent = topg * multiplier;
                yScrol = sectionScrollPointY + topGetParent;
              } else {
                let topGetParent = topg * countThreeRow;
                countThreeRow = countThreeRow + 1;
                yScrol = sectionScrollPointY + topGetParent;
              }
            }
            gsap.to(window, { scrollTo: yScrol, ease: 'none' });
          } else if (methodObject == 'imageWithTextCarousel') {
            const blockSize = sectionObject.getAttribute('data-block-size');
            const focusedElement = event.target;
            const focusedParent = focusedElement.parentElement.closest('[multi-media-item]');
            const focusedBlock = focusedParent.getAttribute('scrollable-block-imwt');
            const scrollDifference = sectionScrollPointY - sectionScrollPointYStart;
            const scrollDivide = scrollDifference / blockSize;
            let percentageValue = 4 * (blockSize - 1);
            let percentDiffernce = (scrollDifference * percentageValue) / 100;
            let scrollYPosition = sectionScrollPointYStart + scrollDivide * (focusedBlock - 1) + percentDiffernce;
            if (focusedBlock == 1) {
              scrollYPosition = sectionScrollPointYStart;
            } else if (focusedBlock == blockSize) {
              scrollYPosition = sectionScrollPointY;
            }
            gsap.to(window, { scrollTo: scrollYPosition, ease: 'none' });
          } else if (methodObject == 'verticalCarousel') {
            const blockSize = sectionObject.getAttribute('data-block-size');
            const focusedElement = event.target;
            const focusedParent = focusedElement.parentElement.closest('[vertical-circle-content]');
            const focusedBlock = focusedParent.getAttribute('vc-block-content-index');
            const scrollDifference = sectionScrollPointY - sectionScrollPointYStart;
            const scrollDivide = scrollDifference / blockSize;
            let scrollYPosition = sectionScrollPointYStart + scrollDivide * focusedBlock;
            let finalScrollYPosition = scrollYPosition - 50 * focusedBlock;
            if (blockSize == focusedBlock) {
              finalScrollYPosition = sectionScrollPointY;
            }
            gsap.to(window, { scrollTo: finalScrollYPosition, ease: 'none' });
          } else if (methodObject == 'bannerSlider') {
            const focusedElement = event.target;
            const focusedParent = focusedElement.parentElement.closest('[banner-slider-overlay-content]');
            if (focusedParent != null) {
              let scrollPosition = sectionScrollPointY;
              gsap.to(window, { scrollTo: scrollPosition, ease: 'none' });
            } else {
              if (isShiftTab) {
                gsap.to(window, { scrollTo: sectionScrollPointYStart, ease: 'none' });
              }
            }
          } else if (methodObject == 'scrollSlidesBanner') {
            const blockSize = sectionObject.getAttribute('data-block-size');
            const allProgressButton = sectionObject.querySelectorAll('[scroll-slide-progress]');
            const focusedElement = event.target;
            const focusedParent = focusedElement.parentElement.closest('[scroll-slide-item]');
            if (focusedParent != null) {
              const focusedBlock = focusedParent.getAttribute('data-count');
              const focusIndex = parseInt(focusedParent.getAttribute('data-count'), 10) - 1;
              allProgressButton[focusIndex].click();
            }
          } else if (methodObject == 'mediaWithCards') {
            gsap.to(window, { scrollTo: sectionScrollPointY, ease: 'none' });
          } else {
            gsap.to(window, { scrollTo: sectionScrollPointY, ease: 'none' });
          }
        }
      }
    });
    sectionObject.addEventListener('focusout', (event) => {
      if (!sectionObject.contains(document.activeElement)) {
        this.lastFocusedSectionTab = null;
      }
    });
  }
}
